"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach(function (summary) {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', function (event) {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
var trapFocusHandlers = {};
function trapFocus(container) {
  var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = function (event) {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (_unused) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  var navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  var currentFocusedElement = null;
  var mouseClick = null;
  window.addEventListener('keydown', function (event) {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener('mousedown', function (event) {
    mouseClick = true;
  });
  window.addEventListener('focus', function () {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(function (video) {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(function (video) {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(function (video) {
    return video.pause();
  });
  document.querySelectorAll('product-model').forEach(function (model) {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus() {
  var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  var openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  var summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
var Customizer = /*#__PURE__*/function () {
  function Customizer() {
    _classCallCheck(this, Customizer);
    this.allColourSiblingSelectors = document.querySelectorAll('colour-sibling');
    this.cartModal = document.querySelector('cart-modal');
    this.items;
    this.frontItemQty = 0;
    this.frontAutoItemQty = 0;
    this.frontBackItemQty = 0;
    this.frontBackAutoItemQty = 0;
    this.frontFeesQty = 0;
    this.frontBackFeesQty = 0;
    this.frontAutoFeeQty = 0;
    this.frontBackAutoFeeQty = 0;
    this.frontBackMixedFeeQty = 0;
    this.premFeeQty = 0;
    this.totalCustomizedUnits = 0;
    this.maxCustomizedUnits = 49;
    this.frontFeeId = this.cartModal.dataset.frontCustomisationId;
    this.frontAutoFeeId = this.cartModal.dataset.frontAutoFeeId;
    this.frontBackAutoFeeId = this.cartModal.dataset.frontBackAutoFeeId;
    this.frontBackFeeId = this.cartModal.dataset.frontbackCustomisationId;
    this.frontBackMixedFeeId = this.cartModal.dataset.frontBackMixedFeeId;
    this.premFeeId = this.cartModal.dataset.premiumCustomisationId;
    this.setCustomEventListeners();
    this.setEventListener();
  }
  _createClass(Customizer, [{
    key: "refreshCustomizationInDom",
    value: function refreshCustomizationInDom() {
      // METHOD FOR RE-INIT CUSTOMIZATION ELEMENTS IN THE DOM FOLLOWING A SECTION RENDER
      this.allColourSiblingSelectors = document.querySelectorAll('colour-sibling');
      this.setCustomEventListeners();
      this.allColourSiblingSelectors.forEach(function (sibling) {
        if (!sibling.offShelfCust) {
          sibling.dispatchEvent(sibling.toggleCustomizeEvt, 'toggle-customizer-button');
        }
      });
      Array.from(document.querySelectorAll('.product-customize-btn')).forEach(function (btn) {
        if (!btn.classList.contains('.product-corporate-customize')) {
          btn.addEventListener('click', function (event) {
            handleCustomizer(event);
          });
        }
      });
    }
  }, {
    key: "setEventListener",
    value: function setEventListener() {
      Array.from(document.querySelectorAll('.product-customize-btn')).forEach(function (btn) {
        if (!btn.classList.contains('.product-corporate-customize')) {
          btn.addEventListener('click', function (event) {
            handleCustomizer(event);
          });
        }
      });
    }
  }, {
    key: "setCustomEventListeners",
    value: function setCustomEventListeners() {
      var _this = this;
      // Variant Picker based event listeners
      this.allColourSiblingSelectors.forEach(function (colourSibling) {
        colourSibling.addEventListener('quick-add-colour-change-cust', function () {
          _this.handleQuickAddCustomizerColourChange();
        });
        colourSibling.addEventListener('toggle-customizer-button', function () {
          _this.toggleCustomizeButton();
        });
      });

      // Cart Modal based event listeners
      this.cartModal.addEventListener('handle-customization-fees', function () {
        _this.handleCustomizationFees();
      });
    }

    // Methods relating to Colour Siblings
  }, {
    key: "handleQuickAddCustomizerColourChange",
    value: function handleQuickAddCustomizerColourChange() {
      // THIS METHOD largely only affects TO D2C USECASES, FOR CORPORATE SALES SEE updateCorporateCustomizeBtn() which is called at the end of this method if certain conditions are met.
      var relevantColourSibling = event.currentTarget;
      var customizeBtn = relevantColourSibling.usage === 'quick-add' ? relevantColourSibling.closest('quick-add').querySelector('.product-customize-btn:not(.product-corporate-customize)') : relevantColourSibling.querySelector('.product-customize-btn');
      if (customizeBtn) {
        var customizerDataJson = relevantColourSibling.querySelector(".json__colour_siblings");
        if (customizerDataJson) {
          var customizerData = relevantColourSibling.querySelector(".json__colour_siblings") ? JSON.parse(relevantColourSibling.querySelector(".json__colour_siblings").textContent) : null;
          var currentVarCustomizeData = customizerData.find(function (data) {
            return data.variantId == relevantColourSibling.currentVariantId;
          });
          if (currentVarCustomizeData.customizer_upk != '' && currentVarCustomizeData['enabled_d2c'] == 'true') {
            customizeBtn.dataset.handle = currentVarCustomizeData.customizer_upk;
          }
        }
      }
    }
  }, {
    key: "toggleCustomizeButton",
    value: function toggleCustomizeButton() {
      var relevantColourSibling = event.currentTarget;
      var customizerData = relevantColourSibling.querySelector(".json__colour_siblings") ? JSON.parse(relevantColourSibling.querySelector(".json__colour_siblings").textContent) : null;
      if (customizerData != null) {
        var currentVarCustomizeData = customizerData.find(function (data) {
          return data.variantId == relevantColourSibling.currentVariantId;
        });
        var isAvailable = (currentVarCustomizeData === null || currentVarCustomizeData === void 0 ? void 0 : currentVarCustomizeData.available) === 'true' ? true : false;
        var variantId = currentVarCustomizeData === null || currentVarCustomizeData === void 0 ? void 0 : currentVarCustomizeData.variantId;
        var customizeBtn;
        if (relevantColourSibling.usage === 'main-product') {
          customizeBtn = document.getElementById("product-customize-button");
        } else {
          var targetContainer = relevantColourSibling.closest(relevantColourSibling.usage) || relevantColourSibling.closest(".".concat(relevantColourSibling.usage));
          customizeBtn = targetContainer.querySelectorAll('.product-customize-btn:not(.product-corporate-customize)');
        }
        if (!customizeBtn) {
          return;
        }
        var notAvailableForCustomization = (currentVarCustomizeData === null || currentVarCustomizeData === void 0 ? void 0 : currentVarCustomizeData.customizer_upk) == '' || !isAvailable || (currentVarCustomizeData === null || currentVarCustomizeData === void 0 ? void 0 : currentVarCustomizeData.enabled_d2c) != 'true';
        if (relevantColourSibling.usage == "main-product") {
          if (notAvailableForCustomization) {
            customizeBtn.forEach(function (button) {
              button.setAttribute("disabled", "disabled");
              button.classList.add('disabled');
            });
          } else {
            customizeBtn.forEach(function (button) {
              button.removeAttribute("disabled");
              button.dataset.handle = currentVarCustomizeData.customizer_upk;
              button.dataset.id = variantId;
              button.classList.remove('disabled');
            });
          }
        } else {
          if (notAvailableForCustomization) {
            customizeBtn.forEach(function (button) {
              button.style.visibility = "hidden";
              button.classList.add("disabled");
            });
          } else if (currentVarCustomizeData.is_early_access_product === "true" && !window.isCustomerLoggedIn) {
            customizeBtn.forEach(function (button) {
              button.style.visibility = "visible";
              button.classList.add("disabled");
            });
          } else {
            customizeBtn.forEach(function (button) {
              button.style.visibility = "visible";
              button.classList.remove("disabled");
              button.dataset.handle = currentVarCustomizeData.customizer_upk;
              button.dataset.id = variantId;
            });
          }
        }
      }
    }

    // Methods relating to Cart Modal
    // Gets cart data from Shopify, stores it in class props
  }, {
    key: "getCart",
    value: function () {
      var _getCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var cartData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch('/cart.js', {
                  method: "GET",
                  ContentType: "application/json"
                }).then(function (response) {
                  return response.json();
                }).then(function (data) {
                  return data;
                });
              case 2:
                cartData = _context.sent;
                this.items = cartData.items;
                this.cartState = cartData;
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getCart() {
        return _getCart.apply(this, arguments);
      }
      return getCart;
    }() // Iterates through the item.properties object to create simple Obj with customization location and quantity
  }, {
    key: "formatCustomizationData",
    value: function () {
      var _formatCustomizationData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
        var customizationLocation, isPremium, customizationType, prop, _item$properties$prop;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                customizationLocation = null;
                isPremium = false;
                customizationType = null;
                for (prop in item.properties) {
                  if (prop.includes('_customization')) {
                    if (customizationLocation === null) {
                      customizationLocation = item.properties[prop].location;
                    } else {
                      customizationLocation = 'front-back';
                    }
                    if (((_item$properties$prop = item.properties[prop]) === null || _item$properties$prop === void 0 ? void 0 : _item$properties$prop["_isPremium"]) === true) {
                      isPremium = true;
                    }
                    if (customizationType === null) {
                      customizationType = item.properties[prop].type;
                    }
                    if (customizationLocation === 'front-back' && customizationType !== 'autoimage' && item.properties[prop].type === 'autoimage') {
                      customizationType = 'front-back-mixed';
                    }
                    if (customizationLocation === 'front-back' && customizationType === 'autoimage' && item.properties[prop].type !== 'autoimage') {
                      customizationType = 'front-back-mixed';
                    }
                  }
                }
                return _context2.abrupt("return", {
                  customizationLocation: customizationLocation,
                  quantity: item.quantity,
                  isPremium: isPremium,
                  customizationType: customizationType
                });
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function formatCustomizationData(_x) {
        return _formatCustomizationData.apply(this, arguments);
      }
      return formatCustomizationData;
    }() // Counts the quantity of customized items for front, front/back and total customized units
  }, {
    key: "countCustomizedItems",
    value: function () {
      var _countCustomizedItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.frontItemQty = 0;
                this.frontBackItemQty = 0;
                this.premItemQty = 0;
                this.frontAutoItemQty = 0;
                this.frontBackAutoItemQty = 0;
                this.frontBackMixedItemQty = 0;
                this.totalCustomizedUnits = 0;
                this.items.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(item) {
                    var formattedData;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(item.properties !== null && item.properties["_customized"] == true)) {
                              _context3.next = 8;
                              break;
                            }
                            _context3.next = 3;
                            return _this2.formatCustomizationData(item);
                          case 3:
                            formattedData = _context3.sent;
                            if (formattedData.customizationLocation === 'front' && (formattedData === null || formattedData === void 0 ? void 0 : formattedData.isPremium) !== true && formattedData.customizationType !== 'autoimage' && formattedData.customizationType !== 'front-back-mixed') {
                              _this2.frontItemQty += item.quantity;
                            } else if (formattedData.customizationLocation === 'front-back' && (formattedData === null || formattedData === void 0 ? void 0 : formattedData.isPremium) !== true && formattedData.customizationType !== 'autoimage' && formattedData.customizationType !== 'front-back-mixed') {
                              _this2.frontBackItemQty += item.quantity;
                            } else if ((formattedData === null || formattedData === void 0 ? void 0 : formattedData.isPremium) === true) {
                              _this2.premItemQty += item.quantity;
                            } else if (formattedData.customizationLocation === 'front' && formattedData.isPremium !== true && formattedData.customizationType === 'autoimage') {
                              _this2.frontAutoItemQty += item.quantity;
                            } else if (formattedData.customizationLocation === 'front-back' && formattedData.isPremium !== true && formattedData.customizationType === 'autoimage') {
                              _this2.frontBackAutoItemQty += item.quantity;
                            } else if (formattedData.customizationLocation === 'front-back' && formattedData.isPremium !== true && formattedData.customizationType === 'front-back-mixed') {
                              _this2.frontBackMixedItemQty += item.quantity;
                            }
                            _this2.totalCustomizedUnits += item.quantity;
                            _context3.next = 9;
                            break;
                          case 8:
                            return _context3.abrupt("return");
                          case 9:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));
                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function countCustomizedItems() {
        return _countCustomizedItems.apply(this, arguments);
      }
      return countCustomizedItems;
    }() // Counts the number of customizer fees currently in the cart
  }, {
    key: "countCustomizerFees",
    value: function () {
      var _countCustomizerFees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this3 = this;
        var currentFrontFees, currentFrontBackFees, currentPremFees, currentFrontAutoFees, currentFrontBackAutoFees, currentFrontBackMixedFees;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                currentFrontFees = 0;
                currentFrontBackFees = 0;
                currentPremFees = 0;
                currentFrontAutoFees = 0;
                currentFrontBackAutoFees = 0;
                currentFrontBackMixedFees = 0;
                this.items.forEach( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(item) {
                    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (item.variant_id === parseInt(_this3.frontFeeId)) {
                              currentFrontFees += item.quantity;
                            } else if (item.variant_id === parseInt(_this3.frontBackFeeId)) {
                              currentFrontBackFees += item.quantity;
                            } else if (item.variant_id === parseInt(_this3.premFeeId)) {
                              currentPremFees += item.quantity;
                            } else if (item.variant_id === parseInt(_this3.frontAutoFeeId)) {
                              currentFrontAutoFees += item.quantity;
                            } else if (item.variant_id === parseInt(_this3.frontBackAutoFeeId)) {
                              currentFrontBackAutoFees += item.quantity;
                            } else if (item.variant_id === parseInt(_this3.frontBackMixedFeeId)) {
                              currentFrontBackMixedFees += item.quantity;
                            }
                          case 1:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));
                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                this.frontFeesQty = currentFrontFees;
                this.frontBackFeesQty = currentFrontBackFees;
                this.premFeeQty = currentPremFees;
                this.frontAutoFeeQty = currentFrontAutoFees;
                this.frontBackAutoFeeQty = currentFrontBackAutoFees;
                this.frontBackMixedFeeQty = currentFrontBackMixedFees;
              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function countCustomizerFees() {
        return _countCustomizerFees.apply(this, arguments);
      }
      return countCustomizerFees;
    }() // Checks if qty of fee item is less than 1, if it's less it fires the add.js Cart AJAX API and adds the appropriate # of fee items
    // If the qty is higher than 1, it uses the change.js Cart AJAX API to update the qty of fee items for that location
    // In order for the to call updateCartModal() from cartModal the section id's are passed in the formData
  }, {
    key: "adjustFeeQty",
    value: function () {
      var _adjustFeeQty = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(feeId, feeQty, itemQty) {
        var _this4 = this;
        var formData, productForm;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                formData = {};
                productForm = this.checkForProductForm();
                if (!(feeQty < 1)) {
                  _context7.next = 8;
                  break;
                }
                formData.items = [{
                  id: parseInt(feeId),
                  quantity: itemQty,
                  properties: {
                    "_customizationCost": true
                  }
                }];
                _context7.next = 6;
                return productForm.callAjaxApi(JSON.stringify(formData));
              case 6:
                _context7.next = 14;
                break;
              case 8:
                formData.sections = ["cart-modal-items", "cart-modal-button", "cart-modal-subtotal", "cart-icon-bubble"];
                formData.sections_url = window.location.pathname;
                formData.id = feeId;
                formData.quantity = itemQty;
                _context7.next = 14;
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/javascript'
                  },
                  body: JSON.stringify(formData)
                }).then(function (response) {
                  return response.json();
                }).then(function (state) {
                  _this4.items = state.items;
                  _this4.cartState = state;
                })["finally"](function () {
                  _this4.cartModal.updateCartModal(_this4.cartState);
                  _this4.cartModal.updateFreeShippingNotices();
                });
              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function adjustFeeQty(_x4, _x5, _x6) {
        return _adjustFeeQty.apply(this, arguments);
      }
      return adjustFeeQty;
    }()
  }, {
    key: "checkForProductForm",
    value: function checkForProductForm() {
      var productForm = document.querySelector('product-form');
      if (productForm !== null) {
        return productForm;
      } else {
        productForm = new ProductForm();
        return productForm;
      }
    }
  }, {
    key: "setCartAttribute",
    value: function () {
      var _setCartAttribute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var cartAttributeValue;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cartAttributeValue = false;
                this.items.forEach(function (item) {
                  if (item.properties['_requires_review'] === true) {
                    cartAttributeValue = true;
                  }
                });
                _context8.next = 4;
                return fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-type": "application/json",
                    Accept: "application/javascript"
                  },
                  body: JSON.stringify({
                    attributes: {
                      "moderation_required": "".concat(cartAttributeValue)
                    }
                  })
                });
              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function setCartAttribute() {
        return _setCartAttribute.apply(this, arguments);
      }
      return setCartAttribute;
    }() // Higher Order Function that dictates flow of logic for customization fees
  }, {
    key: "handleCustomizationFees",
    value: function () {
      var _handleCustomizationFees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.getCart();
              case 2:
                _context9.next = 4;
                return this.setCartAttribute();
              case 4:
                _context9.next = 6;
                return this.countCustomizedItems();
              case 6:
                if (!(this.totalCustomizedUnits > 0)) {
                  _context9.next = 29;
                  break;
                }
                _context9.next = 9;
                return this.countCustomizerFees();
              case 9:
                if (!(this.frontFeesQty != this.frontItemQty)) {
                  _context9.next = 12;
                  break;
                }
                _context9.next = 12;
                return this.adjustFeeQty(this.frontFeeId, this.frontFeesQty, this.frontItemQty);
              case 12:
                if (!(this.frontBackFeesQty != this.frontBackItemQty)) {
                  _context9.next = 15;
                  break;
                }
                _context9.next = 15;
                return this.adjustFeeQty(this.frontBackFeeId, this.frontBackFeesQty, this.frontBackItemQty);
              case 15:
                if (!(this.premFeeQty != this.premItemQty)) {
                  _context9.next = 18;
                  break;
                }
                _context9.next = 18;
                return this.adjustFeeQty(this.premFeeId, this.premFeeQty, this.premItemQty);
              case 18:
                if (!(this.frontAutoFeeQty != this.frontAutoItemQty)) {
                  _context9.next = 21;
                  break;
                }
                _context9.next = 21;
                return this.adjustFeeQty(this.frontAutoFeeId, this.frontAutoFeeQty, this.frontAutoItemQty);
              case 21:
                if (!(this.frontBackAutoFeeQty != this.frontBackAutoItemQty)) {
                  _context9.next = 24;
                  break;
                }
                _context9.next = 24;
                return this.adjustFeeQty(this.frontBackAutoFeeId, this.frontBackAutoFeeQty, this.frontBackAutoItemQty);
              case 24:
                if (!(this.frontBackMixedFeeQty != this.frontBackMixedItemQty)) {
                  _context9.next = 27;
                  break;
                }
                _context9.next = 27;
                return this.adjustFeeQty(this.frontBackMixedFeeId, this.frontBackMixedFeeQty, this.frontBackMixedItemQty);
              case 27:
                _context9.next = 49;
                break;
              case 29:
                _context9.next = 31;
                return this.countCustomizerFees();
              case 31:
                if (!(this.frontFeesQty > 0)) {
                  _context9.next = 34;
                  break;
                }
                _context9.next = 34;
                return this.adjustFeeQty(this.frontFeeId, 1, 0);
              case 34:
                if (!(this.frontBackFeesQty > 0)) {
                  _context9.next = 37;
                  break;
                }
                _context9.next = 37;
                return this.adjustFeeQty(this.frontBackFeeId, 1, 0);
              case 37:
                if (!(this.premFeeQty > 0)) {
                  _context9.next = 40;
                  break;
                }
                _context9.next = 40;
                return this.adjustFeeQty(this.premFeeId, 1, 0);
              case 40:
                if (!(this.frontAutoFeeQty > 0)) {
                  _context9.next = 43;
                  break;
                }
                _context9.next = 43;
                return this.adjustFeeQty(this.frontAutoFeeId, 1, 0);
              case 43:
                if (!(this.frontBackAutoFeeQty > 0)) {
                  _context9.next = 46;
                  break;
                }
                _context9.next = 46;
                return this.adjustFeeQty(this.frontBackAutoFeeId, 1, 0);
              case 46:
                if (!(this.frontBackMixedFeeQty > 0)) {
                  _context9.next = 49;
                  break;
                }
                _context9.next = 49;
                return this.adjustFeeQty(this.frontBackMixedFeeId, 1, 0);
              case 49:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
      function handleCustomizationFees() {
        return _handleCustomizationFees.apply(this, arguments);
      }
      return handleCustomizationFees;
    }()
  }]);
  return Customizer;
}();
var customizerObj = new Customizer();
var QuantityInput = /*#__PURE__*/function (_HTMLElement) {
  _inherits(QuantityInput, _HTMLElement);
  var _super = _createSuper(QuantityInput);
  function QuantityInput() {
    var _this5;
    _classCallCheck(this, QuantityInput);
    _this5 = _super.call(this);
    _this5.input = _this5.querySelector('input');
    _this5.changeEvent = new Event('change', {
      bubbles: true
    });
    _this5.querySelectorAll('button').forEach(function (button) {
      return button.addEventListener('click', _this5.onButtonClick.bind(_assertThisInitialized(_this5)));
    });
    return _this5;
  }
  _createClass(QuantityInput, [{
    key: "onButtonClick",
    value: function onButtonClick(event) {
      event.preventDefault();
      var previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }]);
  return QuantityInput;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  var _this6 = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this6, args);
    }, wait);
  };
}
function fetchConfig() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'json';
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': "application/".concat(type)
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
var currencySymbol = document.getElementById("_int").dataset.currency;
var currencyDelimiter = document.getElementById("_int").dataset.delimiter;
var placeholder = currencyDelimiter === '.' ? '{{amount}}' : '{{amount_with_comma_separator}}';
Shopify.moneyFormat = "".concat(currencySymbol).concat(placeholder);
Shopify.formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number === null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
Shopify.breakpoints = {
  mobile: 749,
  tablet: 989,
  desktop: 1440
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function initCountry() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function initProvince() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function setOptions(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
if (typeof window.Theme == 'undefined') {
  window.Theme = {};
}

//used in snippet/facets.liquid /rendered in section/main-collection-product-grid.liquid / also used in custom element header-drawer
var MenuDrawer = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(MenuDrawer, _HTMLElement2);
  var _super2 = _createSuper(MenuDrawer);
  function MenuDrawer() {
    var _this7;
    _classCallCheck(this, MenuDrawer);
    _this7 = _super2.call(this);
    _this7.mainDetailsToggle = _this7.querySelector('details');
    // this.header = this.header || document.querySelector('.section-header');
    //Props for specifc use cases to power customs methods - where did this come from? 
    _this7.productAtc = document.querySelector('product-atc');

    // if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    // view port height variable, no longer just for just iphone as above
    // let setMobileHeight = (e) => {
    // 	document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    // }
    // document.addEventListener('DOMContentLoaded', setMobileHeight);
    // window.addEventListener('resize', setMobileHeight);

    _this7.addEventListener('keyup', _this7.onKeyUp.bind(_assertThisInitialized(_this7)));
    _this7.addEventListener('focusout', _this7.onFocusOut.bind(_assertThisInitialized(_this7)));
    _this7.bindEvents();
    return _this7;
  }
  _createClass(MenuDrawer, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this8 = this;
      this.querySelectorAll('summary').forEach(function (summary) {
        return summary.addEventListener('click', _this8.onSummaryClick.bind(_this8));
      });
      this.querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)').forEach(function (button) {
        return button.addEventListener('click', _this8.onCloseButtonClick.bind(_this8));
      });
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      var openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  }, {
    key: "onSummaryClick",
    value: function onSummaryClick(event) {
      var _detailsElement$paren, _grandParentElement$c;
      var summaryElement = event.currentTarget;
      var detailsElement = summaryElement.parentNode;
      var parentMenuElement = detailsElement.closest('.has-submenu');
      var isOpen = detailsElement.hasAttribute('open');
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      // Check if the grandparent has the specific class
      var grandParentElement = detailsElement === null || detailsElement === void 0 ? void 0 : (_detailsElement$paren = detailsElement.parentElement) === null || _detailsElement$paren === void 0 ? void 0 : _detailsElement$paren.parentElement;
      if (grandParentElement !== null && grandParentElement !== void 0 && (_grandParentElement$c = grandParentElement.classList) !== null && _grandParentElement$c !== void 0 && _grandParentElement$c.contains('menu-drawer__level-2')) {
        // Get the parent of the detailsElement
        var parentElement = detailsElement.parentElement;

        // Iterate through siblings of the parent and close their dropdowns
        Array.from(parentElement.parentElement.children).forEach(function (child) {
          if (child !== parentElement) {
            var firstChild = child.firstElementChild;
            if (firstChild) {
              firstChild.classList.remove('menu-opening');
              firstChild.removeAttribute('open');
              if (firstChild.firstElementChild) {
                firstChild.firstElementChild.setAttribute('aria-expanded', false);
              }
            }
          }
        });
      }
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', "".concat(window.innerHeight, "px"));
        }
      } else {
        setTimeout(function () {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
          Sibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }

      //Call custom methods in specific use cases - what is this for? ATC handling in facets
      if (this.productAtc) this.productAtcHandling(isOpen, summaryElement);
    }
  }, {
    key: "openMenuDrawer",
    value: function openMenuDrawer(summaryElement) {
      var _this9 = this;
      setTimeout(function () {
        _this9.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add("overflow-hidden-".concat(this.dataset.breakpoint));
      this.sortByModalObserver(event);
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(event) {
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (event === undefined) return;
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(function (submenu) {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove("overflow-hidden-".concat(this.dataset.breakpoint));
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (event instanceof KeyboardEvent) elementToFocus === null || elementToFocus === void 0 ? void 0 : elementToFocus.setAttribute('aria-expanded', false);
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut() {
      var _this10 = this;
      setTimeout(function () {
        if (_this10.mainDetailsToggle.hasAttribute('open') && !_this10.mainDetailsToggle.contains(document.activeElement)) _this10.closeMenuDrawer();
      });
    }
  }, {
    key: "onCloseButtonClick",
    value: function onCloseButtonClick(event) {
      var detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }, {
    key: "closeSubmenu",
    value: function closeSubmenu(detailsElement) {
      var parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  }, {
    key: "closeAnimation",
    value: function closeAnimation(detailsElement) {
      var animationStart;
      var handleAnimation = function handleAnimation(time) {
        if (animationStart === undefined) {
          animationStart = time;
        }
        var elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      };
      window.requestAnimationFrame(handleAnimation);
    }
  }, {
    key: "productAtcHandling",
    value: function productAtcHandling(isOpen, summaryElement) {
      if (summaryElement.classList.contains('header__icon--menu')) {
        if (!isOpen) {
          this.productAtc.classList.add('hidden');
        } else if (isOpen) {
          this.productAtc.classList.remove('hidden');
        }
      }
    }
  }]);
  return MenuDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('menu-drawer', MenuDrawer);

//HeaderDrawerHelp extends MenuDrawer - used in section/header.liquid
var HeaderDrawer = /*#__PURE__*/function (_MenuDrawer) {
  _inherits(HeaderDrawer, _MenuDrawer);
  var _super3 = _createSuper(HeaderDrawer);
  function HeaderDrawer() {
    var _this11;
    _classCallCheck(this, HeaderDrawer);
    _this11 = _super3.call(this);

    // this.announcementBar = this.announcementBar || document.getElementsByClassName('announcement')[0];
    // this.checkWindowWidth();

    // window.addEventListener('resize', () => {
    // 	this.checkWindowWidth();
    // })
    _defineProperty(_assertThisInitialized(_this11), "onResize", function () {
      _this11.header && document.documentElement.style.setProperty('--header-bottom-position', "".concat(parseInt(_this11.header.getBoundingClientRect().bottom - _this11.borderOffset), "px"));
      document.documentElement.style.setProperty('--viewport-height', "".concat(window.innerHeight, "px"));
    });
    return _this11;
  }
  _createClass(HeaderDrawer, [{
    key: "openMenuDrawer",
    value: function openMenuDrawer(summaryElement) {
      var _this12 = this;
      this.header = this.header || document.querySelector('.section-header');
      // shopify-section-header-mobnav? is this needed 
      this.header.classList.add('shopify-section-header-mobnav');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', "".concat(parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset), "px"));
      this.header.classList.add('menu-open');
      // this.announcementBar.classList.add('hidden');

      setTimeout(function () {
        _this12.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add("overflow-hidden-".concat(this.dataset.breakpoint));
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(event) {
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (event !== undefined) {
        this.header.classList.remove('menu-open');
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        document.body.classList.remove("overflow-hidden-".concat(this.dataset.breakpoint));
        this.header.classList.remove('shopify-section-header-mobnav');
        // this.announcementBar.classList.remove('hidden');
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
        window.removeEventListener('resize', this.onResize);
      }
    }

    // checkWindowWidth() {
    // 	if (window.innerWidth > Shopify.breakpoints.tablet) {
    // 		this.header.classList.remove('shopify-section-header-mobnav');
    // 		this.announcementBar.classList.remove('hidden');
    // 	}
    // }
  }]);
  return HeaderDrawer;
}(MenuDrawer);
customElements.define('header-drawer', HeaderDrawer);

//HeaderDrawerHelp extends MenuDrawer - used in section/header.liquid
var HeaderDrawerHelp = /*#__PURE__*/function (_MenuDrawer2) {
  _inherits(HeaderDrawerHelp, _MenuDrawer2);
  var _super4 = _createSuper(HeaderDrawerHelp);
  function HeaderDrawerHelp() {
    var _this13;
    _classCallCheck(this, HeaderDrawerHelp);
    _this13 = _super4.call(this);

    // this.announcementBar = this.announcementBar || document.getElementsByClassName('announcement')[0];
    // this.checkWindowWidth();

    // window.addEventListener('resize', () => {
    // 	this.checkWindowWidth();
    // })
    _defineProperty(_assertThisInitialized(_this13), "onResize", function () {
      _this13.header && document.documentElement.style.setProperty('--header-bottom-position', "".concat(parseInt(_this13.header.getBoundingClientRect().bottom - _this13.borderOffset), "px"));
      document.documentElement.style.setProperty('--viewport-height', "".concat(window.innerHeight, "px"));
    });
    return _this13;
  }
  _createClass(HeaderDrawerHelp, [{
    key: "openMenuDrawer",
    value: function openMenuDrawer(summaryElement) {
      var _this14 = this;
      this.header = this.header || document.querySelector('.section-header');
      // shopify-section-header-mobnav? is this needed 
      // this.header.classList.add('shopify-section-header-mobnav');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', "".concat(parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset), "px"));
      this.header.classList.add('menu-open');
      // this.announcementBar.classList.add('hidden');

      setTimeout(function () {
        _this14.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add("overflow-hidden-".concat(this.dataset.breakpoint));
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(event) {
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (event !== undefined) {
        this.header.classList.remove('menu-open');
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        document.body.classList.remove("overflow-hidden-".concat(this.dataset.breakpoint));
        // this.header.classList.remove('shopify-section-header-mobnav');
        // this.announcementBar.classList.remove('hidden');
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
        window.removeEventListener('resize', this.onResize);
      }
    }

    // checkWindowWidth() {
    // 	if (window.innerWidth > Shopify.breakpoints.tablet) {
    // 		this.header.classList.remove('shopify-section-header-mobnav');
    // 		this.announcementBar.classList.remove('hidden');
    // 	}
    // }
  }]);
  return HeaderDrawerHelp;
}(MenuDrawer);
customElements.define('header-drawer-help', HeaderDrawerHelp);
var ModalDialog = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(ModalDialog, _HTMLElement3);
  var _super5 = _createSuper(ModalDialog);
  function ModalDialog() {
    var _this15;
    _classCallCheck(this, ModalDialog);
    _this15 = _super5.call(this);
    _this15.querySelector('[id^="ModalClose-"]').addEventListener('click', _this15.hide.bind(_assertThisInitialized(_this15), false));
    _this15.addEventListener('keyup', function (event) {
      if (event.code.toUpperCase() === 'ESCAPE') _this15.hide();
    });
    if (_this15.classList.contains('media-modal')) {
      _this15.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) _this15.hide();
      });
    } else {
      _this15.addEventListener('click', function (event) {
        if (event.target === _assertThisInitialized(_this15)) _this15.hide();
      });
    }
    return _this15;
  }
  _createClass(ModalDialog, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
      document.body.appendChild(this);
    }
  }, {
    key: "show",
    value: function show(opener) {
      this.openedBy = opener;
      var popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  }, {
    key: "hide",
    value: function hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }]);
  return ModalDialog;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('modal-dialog', ModalDialog);

//used sections/landing-mat.liquid
var LandingMat = /*#__PURE__*/function (_ModalDialog) {
  _inherits(LandingMat, _ModalDialog);
  var _super6 = _createSuper(LandingMat);
  function LandingMat() {
    var _this16;
    _classCallCheck(this, LandingMat);
    _this16 = _super6.call(this);
    _this16.storeCountry = _this16.dataset.storeCountry;
    _this16.storeDomain = _this16.dataset.storeDomain;
    _this16.section = document.getElementById(_this16.parentElement.id);
    _this16.siblingStoreData = Array.from(_this16.querySelector("#SiblingStoreData").children).map(function (store) {
      return JSON.parse(store.innerHTML);
    });
    _this16.testMode = _this16.dataset.testMode;
    _this16.matTitle = _this16.getElementsByClassName('landing-mat-modal__content-title')[0];
    _this16.matMessage = _this16.getElementsByClassName('landing-mat-modal__content-message')[0];
    _this16.matFlag = _this16.getElementsByClassName('landing-mat-modal__content-flag')[0];
    _this16.matRemainLink = _this16.getElementsByClassName('landing-mat-modal__content-remain-link')[0];
    _this16.destroyMat.bind(_assertThisInitialized(_this16));
    return _this16;
  }
  _createClass(LandingMat, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var source = document.referrer;

      //set referrer to external source if test mode enabled
      if (this.testMode) source = "https://www.bbc.co.uk/programmes/m0012fb4";
      if (source && !source.includes(this.storeDomain)) {
        this.userLocation();
      } else {
        this.destroyMat();
      }
    }
  }, {
    key: "userLocation",
    value: function userLocation() {
      var _this17 = this;
      fetch("https://ipinfo.io/?token=8960894bef1c26", {
        headers: {
          'Accept': "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (responseJSON) {
        _this17.checkMatRequired(responseJSON.country);
      });
    }
  }, {
    key: "checkMatRequired",
    value: function checkMatRequired(userLocation) {
      if (userLocation == this.storeCountry) {
        this.destroyMat;
      } else {
        var matContent = this.siblingStoreData.filter(function (store) {
          return store.country == userLocation;
        })[0];
        matContent ? this.loadMat(matContent) : this.destroyMat();
      }
    }
  }, {
    key: "loadMat",
    value: function loadMat(matContent) {
      var _this18 = this;
      this.matTitle.innerText = matContent.title;
      this.matMessage.innerText = matContent.message;
      this.matFlag.srcset = matContent.store_flag;
      this.matRemainLink.innerText = matContent.remain_link;
      setTimeout(function () {
        _this18.setAttribute("open", "");
      }, 500);
      this.matFlag.addEventListener("click", function (e) {
        _this18.classList.add("landing-mat-modal--removal");
        window.location.href = matContent.store_url;
        _this18.destroyMat();
      });
      this.matRemainLink.addEventListener("click", function (e) {
        _this18.classList.add("landing-mat-modal--removal");
        setTimeout(function () {
          _this18.destroyMat();
        }, 1000);
      });
    }
  }, {
    key: "destroyMat",
    value: function destroyMat() {
      this.remove();
    }
  }]);
  return LandingMat;
}(ModalDialog);
customElements.define('landing-mat', LandingMat);

//used in section/collage.liquid, snippets product-popup.liquid and snippets/product-thumbnail.liquid
var ModalOpener = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(ModalOpener, _HTMLElement4);
  var _super7 = _createSuper(ModalOpener);
  function ModalOpener() {
    var _this19;
    _classCallCheck(this, ModalOpener);
    _this19 = _super7.call(this);
    var button = _this19.querySelector('button');
    if (!button) return _possibleConstructorReturn(_this19);
    button.addEventListener('click', function () {
      var modal = document.querySelector(_this19.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
    return _this19;
  }
  return _createClass(ModalOpener);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('modal-opener', ModalOpener);

// used alongside modal-dialog in collage.liquid (video pop up) and video.liquid
var DeferredMedia = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(DeferredMedia, _HTMLElement5);
  var _super8 = _createSuper(DeferredMedia);
  function DeferredMedia() {
    var _this20;
    _classCallCheck(this, DeferredMedia);
    _this20 = _super8.call(this);
    var poster = _this20.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return _possibleConstructorReturn(_this20);
    poster.addEventListener('click', _this20.loadContent.bind(_assertThisInitialized(_this20)));
    return _this20;
  }
  _createClass(DeferredMedia, [{
    key: "loadContent",
    value: function loadContent() {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        var content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.appendChild(content.querySelector('video, model-viewer, iframe'));
        this.videoSrcHandler();
      }
    }
  }, {
    key: "videoSrcHandler",
    value: function videoSrcHandler() {
      var video = this.querySelector('#mp4-video-player');
      if (video !== null) {
        if (window.matchMedia("(min-width: ".concat(Shopify.breakpoints.mobile, "px)")).matches) {
          video.src = video.dataset.desktopSrc;
        } else {
          video.src = video.dataset.mobileSrc;
        }
      }
      this.initiateVideo();
    }
  }, {
    key: "initiateVideo",
    value: function initiateVideo() {
      var _this21 = this;
      this.setAttribute('loaded', true);
      if (this.querySelector('iframe') === null) {
        if (this.dataset.autoplaySetting !== 'true') {
          this.querySelector('video').play();
          this.querySelector('video').addEventListener('click', function () {
            _this21.querySelector('video').paused === true ? play() : pause();
          });
        }
      }
      this.video = this.querySelector('video');
      this.setUpObserver();
    }
  }, {
    key: "setUpObserver",
    value: function setUpObserver() {
      var _this22 = this;
      // for the poster
      this.button = this.querySelector('.deferred-media__poster');
      this.videoBackground = this.querySelector('.video-slide--background');
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          _this22.video.pause();
          _this22.button.style.display = 'block';
          _this22.videoBackground.style.display = 'none';
          _this22.button.addEventListener('click', function () {
            _this22.pausedVideo = _this22.querySelector('video');
            _this22.pausedVideo.play();
            _this22.button.style.display = 'none';
            _this22.videoBackground.style.display = 'block';
          });
        }
      });
      observer.observe(this.video);
    }
  }]);
  return DeferredMedia;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('deferred-media', DeferredMedia);
var DeferredMediaAuto = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(DeferredMediaAuto, _HTMLElement6);
  var _super9 = _createSuper(DeferredMediaAuto);
  function DeferredMediaAuto() {
    var _this23;
    _classCallCheck(this, DeferredMediaAuto);
    _this23 = _super9.call(this);
    var poster = _this23.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener('click', _this23.loadContent.bind(_assertThisInitialized(_this23)));
    }

    // Check for loop attribute on video before setting up observer
    var videoTemplate = _this23.querySelector('template');
    var hasLoop = false;
    if (videoTemplate) {
      var tempDiv = document.createElement('div');
      tempDiv.appendChild(videoTemplate.content.cloneNode(true));
      var video = tempDiv.querySelector('video');
      if (video && video.hasAttribute('loop')) {
        hasLoop = true;
      }
    }
    if (hasLoop) {
      _this23.setupIntersectionObserver();
    }
    return _this23;
  }
  _createClass(DeferredMediaAuto, [{
    key: "setupIntersectionObserver",
    value: function setupIntersectionObserver() {
      var _this24 = this;
      var slide = this.closest('.slider__slide');
      if (!slide) return;
      this._intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!_this24.hasAttribute('loaded')) {
              _this24.loadContent(false);
            } else {
              // Resume video if loaded and paused
              var video = _this24.querySelector('video');
              if (video && video.paused) {
                video.play();
              }
            }
          } else if (!entry.isIntersecting && _this24.hasAttribute('loaded')) {
            // Pause video when not in view
            var _video = _this24.querySelector('video');
            if (_video && !_video.paused) {
              _video.pause();
            }
          }
        });
      }, {
        root: slide.parentElement,
        // the slider viewport
        threshold: 0.6 // adjust as needed
      });

      this._intersectionObserver.observe(slide);
    }
  }, {
    key: "loadContent",
    value: function loadContent() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        var content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        var deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus && deferredElement) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          deferredElement.play();
        }

        // Workaround for safari iframe bug
        var formerStyle = deferredElement.getAttribute('style');
        deferredElement.setAttribute('style', 'display: block;');
        window.setTimeout(function () {
          deferredElement.setAttribute('style', formerStyle);
        }, 0);
      }
    }
  }]);
  return DeferredMediaAuto;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('deferred-media-auto', DeferredMediaAuto);
var SliderComponent = /*#__PURE__*/function (_HTMLElement7) {
  _inherits(SliderComponent, _HTMLElement7);
  var _super10 = _createSuper(SliderComponent);
  function SliderComponent() {
    var _this25;
    _classCallCheck(this, SliderComponent);
    _this25 = _super10.call(this);
    // added
    _this25.initElements();
    _this25.locateButtons();
    if (!_this25.slider || !_this25.nextButton) return _possibleConstructorReturn(_this25);
    _this25.initPages();
    var resizeObserver = new ResizeObserver(function (entries) {
      return _this25.reInit();
    });
    resizeObserver.observe(_this25.slider);
    _this25.setEvents();
    return _this25;
  }
  _createClass(SliderComponent, [{
    key: "reInit",
    value: function reInit() {
      // reInit is called anytime the sliderComponent needs reInitialising.
      // For example, on a resize event
      this.initElements();
      this.locateButtons();
      if (!this.slider || !this.nextButton) return;
      this.initPages();
      this.setEvents();
    }
  }, {
    key: "initElements",
    value: function initElements() {
      // this method defines elements within the sliderComponent
      // It is called in the constructor on page load, and in reInit()
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.slider.querySelectorAll(':scope > [id^="Slide-"]');
      this.sliderItemsToShow = Array.from(this.sliderItems);
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.progressSlider = this.querySelector(':scope .progress-slider');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
    }
  }, {
    key: "setEvents",
    value: function setEvents() {
      var _this26 = this;
      // setEvents() uses elements defined in initElements() and defines their click and scroll listeners
      if (this.prevButton) {
        var prev = this.prevButton.cloneNode(true);
        this.prevButton.replaceWith(prev);
        this.prevButton = prev;
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      if (this.nextButton) {
        var next = this.nextButton.cloneNode(true);
        this.nextButton.replaceWith(next);
        this.nextButton = next;
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      }
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.sliderControlButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          return _this26.onProgressBarButtonClick(event);
        });
      });
    }
  }, {
    key: "locateButtons",
    value: function locateButtons() {
      // locateButtons() finds all sliderComponent buttons within the Slider Component
      var prevButtons = Array.from(this.querySelectorAll('button[name="previous"]')).filter(function (button) {
        return button.clientHeight > 0;
      });
      var sliderButtons = prevButtons.concat(Array.from(this.querySelectorAll('button[name="next"]')).filter(function (button) {
        return button.clientHeight > 0;
      }));
      if (sliderButtons.length > 2) {
        this.locateCorrectSliderButtons(sliderButtons);
      } else {
        this.prevButton = sliderButtons.filter(function (sliderButton) {
          return sliderButton.name === 'previous';
        })[0];
        this.nextButton = sliderButtons.filter(function (sliderButton) {
          return sliderButton.name === 'next';
        })[0];
      }
    }
  }, {
    key: "locateCorrectSliderButtons",
    value: function locateCorrectSliderButtons(sliderButtons) {
      var _this27 = this;
      // In the event multiple pairs of sliderButtons are located in locateButtons()
      // this method ensures the correct pair are assigned to this.prevButton and this.nextButton
      sliderButtons.forEach(function (sliderButton) {
        var buttonParent = sliderButton.closest('slider-component') || sliderButton.closest('slideshow-component') || sliderButton.closest('gallery-component');
        if (buttonParent === _this27) {
          if (sliderButton.name === 'previous') {
            _this27.prevButton = sliderButton;
          } else if (sliderButton.name === 'next') {
            _this27.nextButton = sliderButton;
          }
        }
      });
    }
  }, {
    key: "initPages",
    value: function initPages() {
      // initPages() is called in constructor and reInit()
      // It defines the number of slides, as well as how many sliders per page (AKA how many slides in view)
      // and the total number of pages (number of views)
      // It will also adjust the progressSlider if present
      this.sliderItemsToShow = Array.from(this.sliderItems);
      this.sliderItemsToShow = Array.from(this.sliderItems)
      // fix for when CSS order is in play and this breaks the slider - 
      //  sort sliderItemsToShow by its offsetLeft seeing as that returns us to the initial order of the items in relation to the offset values.
      .filter(function (element) {
        return element.clientWidth > 0;
      }).sort(function (a, b) {
        return a.offsetLeft - b.offsetLeft;
      });
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft === 0 ? this.sliderItemsToShow[0].clientWidth : this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      // use Math.round() to round to nearest integer.
      this.slidesPerPage = Math.round((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      if (this.progressSlider) {
        if (this.totalPages <= 1) {
          this.progressSlider.remove();
        } else {
          if (this.querySelectorAll('.slider-counter__link'.length !== this.totalPages) || !this.querySelector('.slider-counter__link--active')) {
            this.regulateProgressSlider();
          }
        }
      } else {
        // debounce is used to prevent over throttling and exceeding call stack errors
        debounce(this.update(), 200);
      }
    }
    // resetPages used in media-gallery.js / product main thumbnail gallery
  }, {
    key: "resetPages",
    value: function resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  }, {
    key: "update",
    value: function update() {
      // update is fired to update the progressSlider, it's fired whenever the progressSlider is clicked
      // It's also fired when initPages() is fired and no progressSlider is present.
      var previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPage) {
        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = this.currentPage;
          if (this.currentPage > this.sliderControlButtons.length && this.progressSlider) {
            this.totalPages = this.currentPage;
            this.regulateProgressSlider();
          }
          this.pageTotalElement.textContent = this.totalPages;
        }
        if (this.sliderControlButtons.length) {
          this.sliderControlButtons.forEach(function (link) {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
          });
          if (this.sliderControlButtons[this.currentPage - 1] != undefined) {
            this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
            this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
          }
        }
        if (this.currentPage != previousPage) {
          this.dispatchEvent(new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
          }));
        }
        if (this.enableSliderLooping) return;
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
  }, {
    key: "isSlideVisible",
    value: function isSlideVisible(element) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // isSlideVisible is fired to calculate whether a slide is visible
      var lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(event) {
      // fired by the click even listener on next/prev buttons, moves slider accordingly
      event.preventDefault();
      if (this.sliderItemOffset === undefined) {
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      }
      var step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }, {
    key: "onProgressBarButtonClick",
    value: function onProgressBarButtonClick(event) {
      // handles scrolling of sliderComponent to the position of the click on the progressSlider
      event.preventDefault();
      var currentIndex = Array.from(this.sliderControlButtons).indexOf(event.currentTarget);
      if (currentIndex !== -1) {
        this.slider.scrollTo({
          left: currentIndex * this.sliderItemOffset
        });
        this.update();
      }
    }
  }, {
    key: "regulateProgressSlider",
    value: function regulateProgressSlider() {
      var _this28 = this;
      // regulateProgressSlider adjusts the number of incremenets present on the progress slider element.
      var progressSliderDifference = this.totalPages - this.querySelectorAll('.slider-counter__link').length;
      var progressSliderContainer = this.querySelector('.gallery__control-wrapper') != undefined ? this.querySelector('.gallery__control-wrapper') : null;
      if (progressSliderDifference > 0) {
        for (var i = 0; i < progressSliderDifference; i++) {
          var progressSliderItemTemplate = this.querySelector('.slider-counter__link') != undefined ? this.querySelector('.slider-counter__link').outerHTML : null;
          if (progressSliderContainer != null && progressSliderItemTemplate != null) {
            progressSliderContainer.innerHTML += progressSliderItemTemplate;
          }
        }
      } else if (progressSliderDifference < 0) {
        for (var _i = 0; _i < progressSliderDifference * -1; _i++) {
          var progressSliderItems = progressSliderContainer.querySelectorAll('.slider-counter__link');
          progressSliderItems[0].remove();
        }
      }
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.sliderControlButtons.forEach(function (line) {
        line.style.width = "".concat(100 / _this28.totalPages, "%");
      });
      // debounce is used to prevent over throttling and exceeding call stack errors
      debounce(this.update(), 200);
    }
  }]);
  return SliderComponent;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('slider-component', SliderComponent);
var SlideshowComponent = /*#__PURE__*/function (_SliderComponent) {
  _inherits(SlideshowComponent, _SliderComponent);
  var _super11 = _createSuper(SlideshowComponent);
  function SlideshowComponent() {
    var _this29;
    _classCallCheck(this, SlideshowComponent);
    _this29 = _super11.call(this);
    _this29.sliderControlWrapper = _this29.querySelector('.slider-buttons');
    //changed from this.enableSliderLooping = true; to allow for non looping slides when not autoplay
    _this29.enableSliderLooping = _this29.querySelector('.slideshow__autoplay');
    if (!_this29.sliderControlWrapper) return _possibleConstructorReturn(_this29);
    _this29.sliderFirstItemNode = _this29.slider.querySelector('.slideshow__slide');

    // if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    _this29.sliderControlLinksArray = Array.from(_this29.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    _this29.sliderControlLinksArray.forEach(function (link) {
      return link.addEventListener('click', _this29.linkToSlide.bind(_assertThisInitialized(_this29)));
    });
    _this29.slider.addEventListener('scroll', _this29.setSlideVisibility.bind(_assertThisInitialized(_this29)));
    _this29.setSlideVisibility();
    if (_this29.slider.getAttribute('data-autoplay') === 'true') _this29.setAutoPlay();
    return _this29;
  }
  _createClass(SlideshowComponent, [{
    key: "setAutoPlay",
    value: function setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(event) {
      _get(_getPrototypeOf(SlideshowComponent.prototype), "onButtonClick", this).call(this, event);
      var isFirstSlide = this.currentPage === 1;
      var isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      if (!isFirstSlide && !isLastSlide) return;
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }, {
    key: "update",
    value: function update() {
      _get(_getPrototypeOf(SlideshowComponent.prototype), "update", this).call(this);
    }
  }, {
    key: "autoPlayToggle",
    value: function autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  }, {
    key: "focusOutHandling",
    value: function focusOutHandling(event) {
      var focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  }, {
    key: "focusInHandling",
    value: function focusInHandling(event) {
      var focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  }, {
    key: "togglePlayButtonState",
    value: function togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  }, {
    key: "autoRotateSlides",
    value: function autoRotateSlides() {
      var slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }, {
    key: "setSlideVisibility",
    value: function setSlideVisibility() {
      var _this30 = this;
      this.sliderItemsToShow.forEach(function (item, index) {
        var button = item.querySelector('a');
        if (index === _this30.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  }, {
    key: "linkToSlide",
    value: function linkToSlide(event) {
      event.preventDefault();
      var slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }]);
  return SlideshowComponent;
}(SliderComponent);
customElements.define('slideshow-component', SlideshowComponent);
var FreeShipping = /*#__PURE__*/function (_HTMLElement8) {
  _inherits(FreeShipping, _HTMLElement8);
  var _super12 = _createSuper(FreeShipping);
  function FreeShipping() {
    var _this31;
    _classCallCheck(this, FreeShipping);
    _this31 = _super12.call(this);
    if (document.querySelector('free-shipping-notice')) {
      _this31.remainder = _this31.getElementsByClassName('fsn__remainder')[0];
      _this31.threshold = parseInt(_this31.remainder.dataset.threshold);
      _this31.beforeThresholdMessage = _this31.children[0];
      _this31.afterThresholdMessage = _this31.children[1];
      _this31.progressBarMode = _this31.dataset.progress;
    }
    _this31.freeShippingWrapper = document.querySelector(".freeshipping-wrapper");
    _this31.productFsnWrapper = document.querySelector(".pdp-fsn__wrapper");
    return _this31;
  }
  _createClass(FreeShipping, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      this.updateAmount(name, parseInt(oldValue), parseInt(newValue));
    }
  }, {
    key: "fetchFreeShipping",
    value: function () {
      var _fetchFreeShipping = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this32 = this;
        var freeShippingNoticeData;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return fetch("https://".concat(window.location.hostname, "?sections=fsn")).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(response) {
                    var formattedData;
                    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return response.json();
                          case 2:
                            formattedData = _context10.sent;
                            return _context10.abrupt("return", formattedData);
                          case 4:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));
                  return function (_x7) {
                    return _ref3.apply(this, arguments);
                  };
                }()).then(function (formattedData) {
                  var parser = new DOMParser();
                  var markUp = parser.parseFromString(formattedData['fsn'], 'text/html');
                  // const markUp2 = parser.parseFromString(formattedData['fsn'], 'text/html');

                  var freeShippingNotice = markUp.querySelector('.shopify-section');
                  if (freeShippingNotice) {
                    _this32.freeShippingWrapper.append(freeShippingNotice);
                  }
                  return formattedData;
                }).then(function (formattedData) {
                  var newParser = new DOMParser();
                  var markUp2 = newParser.parseFromString(formattedData['fsn'], 'text/html');
                  var mainFreeShippingNotice = markUp2.querySelector('free-shipping-notice');
                  if (_this32.productFsnWrapper != null) {
                    _this32.productFsnWrapper.append(mainFreeShippingNotice);
                  }
                });
              case 2:
                freeShippingNoticeData = _context11.sent;
              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
      function fetchFreeShipping() {
        return _fetchFreeShipping.apply(this, arguments);
      }
      return fetchFreeShipping;
    }()
  }, {
    key: "updateAmount",
    value: function updateAmount(name, oldValue, newValue) {
      var newTotal = newValue;
      var newRemainder = this.threshold - newTotal;
      this.remainder.innerText = '¥' + Number(newRemainder).toLocaleString('ja-JP');
      this.handleMessageFlip(newRemainder);
      if (this.progressBarMode) this.updateProgressBar(newRemainder);
    }
  }, {
    key: "updateProgressBar",
    value: function updateProgressBar(newRemainder) {
      this.progressBar = this.querySelector(".fsn__progress-outer");
      var newProg = (this.threshold - newRemainder) / this.threshold * 100;
      this.progressBar.firstElementChild.style["width"] = "".concat(newProg, "%");
    }
  }, {
    key: "handleMessageFlip",
    value: function handleMessageFlip(newRemainder) {
      if (newRemainder > 0 && !this.afterThresholdMessage.classList.contains("hidden")) {
        this.afterThresholdMessage.classList.add("hidden");
        this.beforeThresholdMessage.classList.remove("hidden");
      } else if (newRemainder <= 0 && !this.beforeThresholdMessage.classList.contains("hidden")) {
        this.beforeThresholdMessage.classList.add("hidden");
        this.afterThresholdMessage.classList.remove("hidden");
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['data-cart-total'];
    }
  }]);
  return FreeShipping;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('free-shipping-notice', FreeShipping);
var fsn = new FreeShipping();
var ProductCard = /*#__PURE__*/function (_HTMLElement9) {
  _inherits(ProductCard, _HTMLElement9);
  var _super13 = _createSuper(ProductCard);
  function ProductCard() {
    var _this33;
    _classCallCheck(this, ProductCard);
    _this33 = _super13.call(this);
    if (_this33.getElementsByClassName("card__product-json")[0]) {
      _this33.product = JSON.parse(_this33.getElementsByClassName("card__product-json")[0].innerText);
    }
    _this33.cardTitleLink = _this33.getElementsByClassName("card-information__text")[0].firstElementChild;
    _this33.cardRatingLink = _this33.getElementsByClassName("card-information__star-rating")[0];
    _this33.cardImageLink = _this33.getElementsByClassName("card__image-link")[0];
    _this33.image = _this33.getElementsByClassName("media")[0].firstElementChild;
    _this33.secondImage = _this33.getElementsByClassName("media")[0].children[1];
    _this33.swatchesContainer = _this33.getElementsByClassName("card__swatch--container")[0];
    _this33.swatches = Array.from(_this33.getElementsByClassName('card__swatch'));
    if (_this33.product) {
      _this33.priceContainer = _this33.product.compare_at_price ? _this33.getElementsByClassName("price__sale")[0] : _this33.getElementsByClassName("price-item")[0];
      _this33.swatchesContainer.addEventListener('click', _this33.onSwatchClick.bind(_assertThisInitialized(_this33)));
    }
    _this33.infoBadges = _this33.querySelector('info-badges');
    return _this33;
  }
  _createClass(ProductCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.handleColourAvailability();
    }
  }, {
    key: "handleColourAvailability",
    value: function handleColourAvailability() {
      var _this34 = this;
      this.swatches.forEach(function (swatch) {
        var colourAvailable = _this34.checkColourAvailability(swatch);
        !colourAvailable ? swatch.classList.add("card__swatch--unavailable") : null;
      });
    }
  }, {
    key: "checkColourAvailability",
    value: function checkColourAvailability(swatch) {
      var colourAvailable = false;
      var swatchColour = swatch.dataset.colourway;
      var variantArr = this.product.variants.filter(function (variant) {
        return variant.option1 === swatchColour;
      });
      variantArr.forEach(function (variant) {
        variant.available ? colourAvailable = true : null;
      });
      return colourAvailable;
    }
  }, {
    key: "onSwatchClick",
    value: function onSwatchClick(e) {
      if (e.target.classList.contains('card__swatch')) {
        this.swatches.forEach(function (swatch) {
          return swatch.classList.remove("card__swatch--selected");
        });
        e.target.classList.add("card__swatch--selected");
        var selectedSwatch = e.target;
        var swatchColour = selectedSwatch.dataset.colourway;
        this.firstMatchingVariant = this.product.variants.find(function (variant) {
          return variant.option1 === swatchColour;
        });
        this.updateImage(selectedSwatch);
        this.secondImage ? this.updateSecondImage(selectedSwatch) : null;
        this.updateLink(selectedSwatch);
        this.updateBadges(selectedSwatch);
      }
    }
  }, {
    key: "updateBadges",
    value: function updateBadges(swatch) {
      var swatchColour = swatch.dataset.colourway;
      var variantArr = this.product.variants.filter(function (variant) {
        return variant.option1 === swatchColour;
      });
      this.infoBadges.toggleBadges(variantArr);
    }
  }, {
    key: "updateImage",
    value: function updateImage(swatch) {
      var newImg = this.getNewPrimaryImage(swatch);
      this.image.srcset = newImg;
    }
  }, {
    key: "getNewPrimaryImage",
    value: function getNewPrimaryImage(swatch) {
      var match = this.product.variants.find(function (variant) {
        return variant.option1 === swatch.dataset.colourway;
      });
      return match.featured_image.src;
    }
  }, {
    key: "updateSecondImage",
    value: function updateSecondImage(swatch) {
      var newIndex = this.product.variants.find(function (variant) {
        return variant.option1 === swatch.dataset.colourway;
      }).featured_image.position;
      this.secondImage.srcset = this.product.images[newIndex];
    }
  }, {
    key: "updateLink",
    value: function updateLink(swatch) {
      var newLink;
      if (document.querySelector('.breadcrumbs__collection') && this.classList.contains('product-card__plp')) {
        var collectionName = document.querySelector('.breadcrumbs__collection');
        var collectionHandle = collectionName.innerText.substr(2).trim().replaceAll(' ', '-').toLowerCase();
        newLink = "/collections/".concat(collectionHandle, "/products/").concat(this.product.handle, "?variant=").concat(this.firstMatchingVariant.id);
      } else {
        newLink = "/products/".concat(this.product.handle, "?variant=").concat(this.firstMatchingVariant.id);
      }
      this.cardTitleLink.href = newLink;
      this.cardRatingLink.href = newLink;
      this.cardImageLink.href = newLink;
    }
  }]);
  return ProductCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-card', ProductCard);
var QuickAdd = /*#__PURE__*/function (_HTMLElement10) {
  _inherits(QuickAdd, _HTMLElement10);
  var _super14 = _createSuper(QuickAdd);
  function QuickAdd() {
    _classCallCheck(this, QuickAdd);
    return _super14.call(this);
  }
  return _createClass(QuickAdd);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('quick-add', QuickAdd);
var InfoBadges = /*#__PURE__*/function (_HTMLElement11) {
  _inherits(InfoBadges, _HTMLElement11);
  var _super15 = _createSuper(InfoBadges);
  function InfoBadges() {
    var _this35;
    _classCallCheck(this, InfoBadges);
    _this35 = _super15.call(this);
    _this35.badges = Array.from(_this35.querySelectorAll('.badge'));
    return _this35;
  }
  _createClass(InfoBadges, [{
    key: "toggleBadge",
    value: function toggleBadge(currentVariant) {
      this.badges.forEach(function (badge) {
        return badge.dataset.variant === currentVariant.title ? badge.classList.remove('hidden') : badge.classList.add('hidden');
      });
    }
  }]);
  return InfoBadges;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('info-badges', InfoBadges);
var VideoBanner = /*#__PURE__*/function (_HTMLElement12) {
  _inherits(VideoBanner, _HTMLElement12);
  var _super16 = _createSuper(VideoBanner);
  function VideoBanner() {
    var _this36;
    _classCallCheck(this, VideoBanner);
    _this36 = _super16.call(this);
    _this36.player = _this36.querySelector('video');
    _this36.controlButton = _this36.querySelector('.video-control__button');
    _this36.playSVG = _this36.querySelector('.video-control__button--play');
    _this36.pauseSVG = _this36.querySelector('.video-control__button--pause');
    _this36.wideBreakPoint = Shopify.breakpoints.mobile + 1;
    _this36.wideViewPort = window.matchMedia("(min-width: ".concat(_this36.wideBreakPoint, "px)"));
    _this36.resizeVideo();
    if (_this36.controlButton) {
      _this36.controlButton.addEventListener('click', function () {
        _this36.pauseSVG.classList.contains('hidden') ? _this36.playVideo() : _this36.pauseVideo();
      });
    }

    // Optionally, auto-play on load
    _this36.addEventListener('DOMContentLoaded', function () {
      _this36.playVideo();
    });
    return _this36;
  }
  _createClass(VideoBanner, [{
    key: "resizeVideo",
    value: function resizeVideo() {
      var src = this.dataset.desktopSrc;
      var poster = this.dataset.desktopPoster;
      if (!this.wideViewPort.matches) {
        if (this.dataset.mobileSrc) src = this.dataset.mobileSrc;
        if (this.dataset.mobilePoster) poster = this.dataset.mobilePoster;
      }
      if (this.player) {
        this.player.src = src;
        if (poster) this.player.poster = poster;
      }
    }
  }, {
    key: "pauseVideo",
    value: function pauseVideo() {
      if (!this.player) return;
      this.player.pause();
      this.pauseSVG.classList.add('hidden');
      this.playSVG.classList.remove('hidden');
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      if (!this.player) return;
      this.player.play();
      this.playSVG.classList.add('hidden');
      this.pauseSVG.classList.remove('hidden');
    }
  }]);
  return VideoBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('video-banner', VideoBanner);
var CartRemoveButton = /*#__PURE__*/function (_HTMLElement13) {
  _inherits(CartRemoveButton, _HTMLElement13);
  var _super17 = _createSuper(CartRemoveButton);
  function CartRemoveButton() {
    var _this37;
    _classCallCheck(this, CartRemoveButton);
    _this37 = _super17.call(this);
    _this37.debouncedOnClick = debounce(function () {
      var container = _this37.closest('cart-modal') || _this37.closest('cart-items');
      container.updateQuantity(_this37.dataset.index, 0);
    }, 500);
    _this37.addEventListener('click', function (event) {
      event.preventDefault();
      _this37.debouncedOnClick();

      //const container = this.closest('cart-modal') || this.closest('cart-items');
      // UpdateQuantity() method fired from cart-modal.js CartModal Class
      //container.updateQuantity(this.dataset.index, 0, '', true);
    });
    return _this37;
  }
  return _createClass(CartRemoveButton);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('cart-remove-button', CartRemoveButton);

// When using AnimatedTextContainer remember to include a unique ID in the HTML
// of whichever custom element you're extending to AnimatedTextContainer to ensure accuracy of textSplitting
var AnimatedTextContainer = /*#__PURE__*/function (_HTMLElement14) {
  _inherits(AnimatedTextContainer, _HTMLElement14);
  var _super18 = _createSuper(AnimatedTextContainer);
  function AnimatedTextContainer() {
    _classCallCheck(this, AnimatedTextContainer);
    return _super18.call(this);
  }
  _createClass(AnimatedTextContainer, [{
    key: "textSplitter",
    value: function textSplitter(targetElement, format) {
      var mySplitText = new SplitText(targetElement, {
        type: "words,chars,lines"
      });
      var chars = mySplitText.chars;
      var words = mySplitText.words;
      var lines = mySplitText.lines;
      switch (format) {
        case 'chars':
          return chars;
        case 'words':
          return words;
        case 'lines':
          return lines;
        default:
          return chars;
      }
    }
  }]);
  return AnimatedTextContainer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
var HeroAnimatedTextContainer = /*#__PURE__*/function (_AnimatedTextContaine) {
  _inherits(HeroAnimatedTextContainer, _AnimatedTextContaine);
  var _super19 = _createSuper(HeroAnimatedTextContainer);
  function HeroAnimatedTextContainer() {
    var _thisSuper, _this38;
    _classCallCheck(this, HeroAnimatedTextContainer);
    _this38 = _super19.call(this);
    _this38.uniqueId = _this38.getAttribute('id');
    _this38.getSplitText = _get((_thisSuper = _assertThisInitialized(_this38), _getPrototypeOf(HeroAnimatedTextContainer.prototype)), "textSplitter", _thisSuper).call(_thisSuper, "#".concat(_this38.uniqueId, " .banner__animated_text"), 'chars');
    _this38.setUpAnimatedText("#".concat(_this38.uniqueId), _this38.getSplitText);
    return _this38;
  }
  _createClass(HeroAnimatedTextContainer, [{
    key: "setUpAnimatedText",
    value: function setUpAnimatedText(triggerElement, targetElement) {
      gsap.to(targetElement, {
        opacity: '1.0',
        y: '0%',
        ease: "none",
        stagger: 0.02,
        scrollTrigger: _defineProperty({
          trigger: triggerElement,
          start: "top 100%",
          end: "100%+=200px 100%",
          scrub: true
        }, "scrub", 0.5)
      });
    }
  }]);
  return HeroAnimatedTextContainer;
}(AnimatedTextContainer);
customElements.define('hero-animated-text-container', HeroAnimatedTextContainer);
var ParallaxContainer = /*#__PURE__*/function (_HTMLElement15) {
  _inherits(ParallaxContainer, _HTMLElement15);
  var _super20 = _createSuper(ParallaxContainer);
  function ParallaxContainer() {
    var _this39;
    _classCallCheck(this, ParallaxContainer);
    _this39 = _super20.call(this);
    _this39.adjustScaleIn = _this39.dataset.adjustScaleIn;
    _this39.adjustScaleOut = _this39.dataset.adjustScaleOut;
    _this39.parallaxAnimation;
    _this39.uniqueId = _this39.getAttribute('id');
    _this39.targetElementArray = ["#".concat(_this39.uniqueId, ".parallax__container > * .parallax__element"), "#".concat(_this39.uniqueId, ".parallax__container > .parallax__element")];
    _this39.setUpParallax(_this39.targetElementArray, "#".concat(_this39.uniqueId, ".parallax__container"), _this39.adjustScaleIn, _this39.adjustScaleOut);
    return _this39;
  }
  _createClass(ParallaxContainer, [{
    key: "setUpParallax",
    value: function setUpParallax(targetSelector, triggerSelector, adjustScaleIn, adjustScaleOut) {
      if (adjustScaleIn != 1) {
        ParallaxContainer.parallaxAnimation = gsap.to(targetSelector, {
          scrollTrigger: _defineProperty({
            trigger: triggerSelector,
            start: '20% top',
            end: 'bottom 0%',
            scrub: true
          }, "scrub", 1.5),
          scale: "".concat(adjustScaleIn)
        });
      }
      if (adjustScaleOut != 1) {
        ParallaxContainer.parallaxAnimation = gsap.from(targetSelector, {
          scrollTrigger: _defineProperty({
            trigger: triggerSelector,
            start: 'top 100%',
            end: '50% 100%',
            scrub: true
          }, "scrub", 1.5),
          scale: "".concat(adjustScaleOut),
          opacity: 0
        });
      }
    }
  }]);
  return ParallaxContainer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('parallax-container', ParallaxContainer);
var ParallaxPinContainer = /*#__PURE__*/function (_HTMLElement16) {
  _inherits(ParallaxPinContainer, _HTMLElement16);
  var _super21 = _createSuper(ParallaxPinContainer);
  function ParallaxPinContainer() {
    var _this40;
    _classCallCheck(this, ParallaxPinContainer);
    _this40 = _super21.call(this);
    _this40.uniqueId = _this40.getAttribute('id');
    _this40.setUpParallax();
    return _this40;
  }
  _createClass(ParallaxPinContainer, [{
    key: "setUpParallax",
    value: function setUpParallax() {
      ScrollTrigger.create({
        trigger: "#".concat(this.uniqueId, " .banner"),
        start: "top top",
        end: "80% top",
        anticipatePin: 1,
        pin: "#".concat(this.uniqueId, " .banner .banner__media"),
        pinnedContainer: "#".concat(this.uniqueId, " .banner")
      });
      ScrollTrigger.create({
        trigger: "#".concat(this.uniqueId, " .banner"),
        start: "top top",
        end: "80% top",
        anticipatePin: 1,
        pin: "#".concat(this.uniqueId, " .banner .banner__content"),
        pinnedContainer: "#".concat(this.uniqueId, " .banner")
      });
    }
  }]);
  return ParallaxPinContainer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('parallax-pin-container', ParallaxPinContainer);
var AnimatedImagesContainer = /*#__PURE__*/function (_HTMLElement17) {
  _inherits(AnimatedImagesContainer, _HTMLElement17);
  var _super22 = _createSuper(AnimatedImagesContainer);
  function AnimatedImagesContainer() {
    var _this41;
    _classCallCheck(this, AnimatedImagesContainer);
    _this41 = _super22.call(this);
    _this41.uniqueId = _this41.getAttribute('id');
    _this41.enableAnimation = _this41.dataset.enableAnimation;
    _this41.animatedImage1 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_1"));
    _this41.animatedImage2 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_2"));
    _this41.animatedImage3 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_3"));
    _this41.animatedImage4 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_4"));
    _this41.animatedImage5 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_5"));
    _this41.animatedImagesArray = [_this41.animatedImage1, _this41.animatedImage2, _this41.animatedImage3, _this41.animatedImage4, _this41.animatedImage5];
    _this41.animatedImageMob1 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_mob_1"));
    _this41.animatedImageMob2 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_mob_2"));
    _this41.animatedImageMob3 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_mob_3"));
    _this41.animatedImageMob4 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_mob_4"));
    _this41.animatedImageMob5 = document.querySelector("#".concat(_this41.uniqueId, " #animated_image_mob_5"));
    _this41.animatedImagesMobArray = [_this41.animatedImageMob1, _this41.animatedImageMob2, _this41.animatedImageMob3, _this41.animatedImageMob4, _this41.animatedImageMob5];
    _this41.setUpScrollAnimation(_this41.enableAnimation, _this41.animatedImagesArray, _this41.animatedImagesMobArray);
    return _this41;
  }
  _createClass(AnimatedImagesContainer, [{
    key: "setUpScrollAnimation",
    value: function setUpScrollAnimation(enableAnimation, animatedImagesArray, animatedImagesMobArray) {
      gsap.registerEffect({
        name: "fadeIn",
        effect: function effect(target) {
          return gsap.from(target, {
            scrollTrigger: {
              trigger: target,
              start: 'center bottom',
              end: 'bottom bottom',
              ease: 'none',
              scrub: true
            },
            opacity: 0
          });
        }
      });
      if (enableAnimation == 'true') {
        animatedImagesArray.forEach(function (animatedImage) {
          if (animatedImage != null) {
            gsap.effects.fadeIn(animatedImage);
          }
        });
        animatedImagesMobArray.forEach(function (animatedImageMob) {
          if (animatedImageMob != null) {
            gsap.effects.fadeIn(animatedImageMob);
          }
        });
      }
    }
  }]);
  return AnimatedImagesContainer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('animated-images-container', AnimatedImagesContainer);
var PromoHero = /*#__PURE__*/function (_AnimatedTextContaine2) {
  _inherits(PromoHero, _AnimatedTextContaine2);
  var _super23 = _createSuper(PromoHero);
  function PromoHero() {
    var _thisSuper2, _this42;
    _classCallCheck(this, PromoHero);
    _this42 = _super23.call(this);
    _this42.breakpoint = _this42.getBreakpoint(window.innerWidth);
    _this42.uniqueId = _this42.closest('.shopify-section').getAttribute('id');
    window.addEventListener('resize', function () {
      debounce(_this42.recalibrate(), 500);
    });
    _this42.introBlockTrigger("#".concat(_this42.uniqueId, " .scrollTrigger__content"));
    _this42.splitTitleObj = _get((_thisSuper2 = _assertThisInitialized(_this42), _getPrototypeOf(PromoHero.prototype)), "textSplitter", _thisSuper2).call(_thisSuper2, "#".concat(_this42.uniqueId, " .scrollTrigger__content #desktop-title"), 'chars');
    _this42.splitTitleObj = new Array(_this42.splitTitleObj);
    _this42.staggerTitleAnimate(_this42.splitTitleObj);
    return _this42;
  }
  _createClass(PromoHero, [{
    key: "getBreakpoint",
    value: function getBreakpoint(viewport) {
      if (viewport < Shopify.breakpoints.mobile) {
        return "(max-width: ".concat(Shopify.breakpoints.mobile, "px)");
      } else if (viewport <= Shopify.breakpoints.tablet) {
        return "(max-width: ".concat(Shopify.breakpoints.tablet, "px)");
      } else {
        return "(min-width: ".concat(++Shopify.breakpoints.tablet, "px)");
      }
    }
  }, {
    key: "recalibrate",
    value: function recalibrate() {
      this.breakpoint = this.getBreakpoint(window.innerWidth);
      this.introBlockTrigger("#".concat(this.uniqueId, " .scrollTrigger__content"));
    }
  }, {
    key: "introBlockTrigger",
    value: function introBlockTrigger(blockTarget) {
      var mm = gsap.matchMedia();
      mm.add(this.breakpoint, function () {
        PromoHero.blockTransition = gsap.to(blockTarget, {
          scrollTrigger: _defineProperty({
            trigger: blockTarget,
            start: '-50% bottom',
            end: "-10% 65%",
            scrub: true
          }, "scrub", 1.5),
          y: '0%',
          opacity: '1.0'
        });
      });
    }
  }, {
    key: "staggerTitleAnimate",
    value: function staggerTitleAnimate(titleChars) {
      titleChars.forEach(function (_char) {
        gsap.to(_char, {
          opacity: '1.0',
          y: '0%',
          ease: "none",
          stagger: 0.02,
          scrollTrigger: _defineProperty({
            trigger: '#desktop-title',
            start: "top bottom",
            end: "bottom 90%",
            scrub: true
          }, "scrub", 1.5)
        });
      });
    }
  }]);
  return PromoHero;
}(AnimatedTextContainer);
customElements.define('promo-hero', PromoHero);
var AnimatedAnchor = /*#__PURE__*/function (_HTMLElement18) {
  _inherits(AnimatedAnchor, _HTMLElement18);
  var _super24 = _createSuper(AnimatedAnchor);
  function AnimatedAnchor() {
    var _this43;
    _classCallCheck(this, AnimatedAnchor);
    _this43 = _super24.call(this);
    // gsap scrollTo anchor second nav
    gsap.registerPlugin(ScrollToPlugin);
    _this43.anchorLinks = gsap.utils.toArray(".second-nav-anchors__container a.section_anchor");
    _this43.setScrollTriggers(_this43.anchorLinks);
    return _this43;
  }
  _createClass(AnimatedAnchor, [{
    key: "setScrollTriggers",
    value: function setScrollTriggers(anchorLinks) {
      var _this44 = this;
      anchorLinks.forEach(function (a) {
        var element = document.querySelector(a.getAttribute("href")),
          linkST = ScrollTrigger.create({
            trigger: element,
            start: "top top"
          });
        ScrollTrigger.create({
          trigger: element,
          start: "top center",
          end: "bottom center",
          onToggle: function onToggle(self) {
            return self.isActive && _this44.setActive(a);
          }
        });
        a.addEventListener("click", function (e) {
          e.preventDefault();
          gsap.to(window, {
            duration: 1,
            scrollTo: linkST.start,
            overwrite: "auto"
          });
        });
      });
    }
  }, {
    key: "setActive",
    value: function setActive(link) {
      this.anchorLinks.forEach(function (el) {
        return el.classList.remove("active");
      });
      link.classList.add("active");
    }
  }]);
  return AnimatedAnchor;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('animated-anchor', AnimatedAnchor);
var HeroAnimatedAnchor = /*#__PURE__*/function (_AnimatedAnchor) {
  _inherits(HeroAnimatedAnchor, _AnimatedAnchor);
  var _super25 = _createSuper(HeroAnimatedAnchor);
  function HeroAnimatedAnchor() {
    var _this45;
    _classCallCheck(this, HeroAnimatedAnchor);
    _this45 = _super25.call(this);
    _this45.uniqueId = _this45.getAttribute('id');
    _this45.heroAnchorLink = gsap.utils.toArray("#".concat(_this45.uniqueId, ".banner__anchor-wrapper a.banner__anchor-link"));
    _this45.setScrollTriggers(_this45.heroAnchorLink);
    _this45.animateLinkOpacity(_this45.heroAnchorLink);
    _this45.arrowElement = document.querySelector("#".concat(_this45.uniqueId, ".banner__anchor-wrapper .banner__anchor-link .icon-arrow"));
    _this45.arrowElement.animate(_this45.animateArrow(), {
      duration: 2000,
      fill: 'forwards',
      iterations: 'Infinity',
      easing: 'ease-in-out'
    });
    return _this45;
  }
  _createClass(HeroAnimatedAnchor, [{
    key: "animateLinkOpacity",
    value: function animateLinkOpacity(targetElement) {
      gsap.to(targetElement, {
        scrollTrigger: {
          trigger: ".banner__content",
          scrub: true,
          start: "top 0%",
          end: "bottom 50%"
        },
        opacity: 0
      });
    }
  }, {
    key: "animateArrow",
    value: function animateArrow() {
      return [{
        transform: 'translateY(0) rotate(90deg)'
      }, {
        transform: 'translateY(-10px) rotate(90deg)'
      }, {
        transform: 'translateY(0) rotate(90deg)'
      }];
    }
  }]);
  return HeroAnimatedAnchor;
}(AnimatedAnchor);
customElements.define('hero-animated-anchor', HeroAnimatedAnchor);
var Tooltip = /*#__PURE__*/function (_HTMLElement19) {
  _inherits(Tooltip, _HTMLElement19);
  var _super26 = _createSuper(Tooltip);
  function Tooltip() {
    var _this46;
    _classCallCheck(this, Tooltip);
    _this46 = _super26.call(this);
    _this46.viewport = _this46.checkViewport();
    _this46.toolTipContainer = _this46.querySelector('.tooltip-container');
    _this46.parent = _this46.closest('.multi-image-block__wrapper');
    if (_this46.viewport > Shopify.breakpoints.tablet) {
      _this46.parent.addEventListener('mouseenter', _this46.revealTooltip.bind(_assertThisInitialized(_this46)));
      _this46.parent.addEventListener('mouseleave', _this46.hideTooltip.bind(_assertThisInitialized(_this46)));
    } else {
      _this46.setupObserver();
    }
    return _this46;
  }
  _createClass(Tooltip, [{
    key: "checkViewport",
    value: function checkViewport() {
      return window.innerWidth;
    }
  }, {
    key: "setupObserver",
    value: function setupObserver() {
      var mobileIntersectionObserver = new IntersectionObserver(this.intersectTooltip.bind(this), {
        threshold: 0.4
      });
      mobileIntersectionObserver.observe(this);
    }
  }, {
    key: "intersectTooltip",
    value: function intersectTooltip(entries, observer) {
      var _this47 = this;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          _this47.revealTooltip();
        } else {
          _this47.hideTooltip();
        }
      });
    }
  }, {
    key: "revealTooltip",
    value: function revealTooltip() {
      this.toolTipContainer.classList.add('active');
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this.toolTipContainer.classList.remove('active');
    }
  }]);
  return Tooltip;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('tool-tip', Tooltip);
var AnimatedContentBanner = /*#__PURE__*/function (_HTMLElement20) {
  _inherits(AnimatedContentBanner, _HTMLElement20);
  var _super27 = _createSuper(AnimatedContentBanner);
  function AnimatedContentBanner() {
    var _this48;
    _classCallCheck(this, AnimatedContentBanner);
    _this48 = _super27.call(this);
    _this48.breakpoint = _this48.getBreakpoint(window.innerWidth);
    _this48.uniqueId = _this48.closest('.shopify-section').getAttribute('id');
    _this48.endPoint;
    window.addEventListener('resize', function () {
      debounce(_this48.recalibrate(), 500);
    });
    _this48.targetSelector = _this48.getAttribute('id');
    _this48.triggerAnimation("#".concat(_this48.targetSelector, " .banner__content"), "#".concat(_this48.uniqueId));
    return _this48;
  }
  _createClass(AnimatedContentBanner, [{
    key: "getBreakpoint",
    value: function getBreakpoint(viewport) {
      if (viewport < Shopify.breakpoints.mobile) {
        this.endPoint = "90%";
        return "(max-width: ".concat(Shopify.breakpoints.mobile, "px)");
      } else if (viewport <= Shopify.breakpoints.tablet) {
        this.endPoint = "90%";
        return "(max-width: ".concat(Shopify.breakpoints.tablet, "px)");
      } else {
        this.endPoint = "40%";
        return "(min-width: ".concat(++Shopify.breakpoints.tablet, "px)");
      }
    }
  }, {
    key: "recalibrate",
    value: function recalibrate() {
      this.breakpoint = this.getBreakpoint(window.innerWidth);
      this.triggerAnimation("#".concat(this.targetSelector, " .banner__content"), "#".concat(this.uniqueId));
    }
  }, {
    key: "triggerAnimation",
    value: function triggerAnimation(targetElem, triggerElem) {
      gsap.to(targetElem, {
        opacity: '1.0',
        y: '0%',
        ease: "none",
        scrollTrigger: {
          trigger: triggerElem,
          start: "top bottom",
          end: "30% ".concat(this.endPoint),
          scrub: true
        }
      });
    }
  }]);
  return AnimatedContentBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('animated-banner-content', AnimatedContentBanner);
var AnimatedGradientCarousel = /*#__PURE__*/function (_AnimatedTextContaine3) {
  _inherits(AnimatedGradientCarousel, _AnimatedTextContaine3);
  var _super28 = _createSuper(AnimatedGradientCarousel);
  function AnimatedGradientCarousel() {
    var _thisSuper3, _thisSuper4, _thisSuper5, _this49;
    _classCallCheck(this, AnimatedGradientCarousel);
    _this49 = _super28.call(this);
    _this49.uniqueId = "#".concat(_this49.closest('.shopify-section').getAttribute('id'));
    _this49.positions = _this49.getPositions(window.innerWidth);
    _this49.positionTargets = _this49.getPositionTargets(_this49.uniqueId);
    _this49.nextSection = _this49.assessNextSection(_this49.uniqueId);
    _this49.morningTextSplit = _get((_thisSuper3 = _assertThisInitialized(_this49), _getPrototypeOf(AnimatedGradientCarousel.prototype)), "textSplitter", _thisSuper3).call(_thisSuper3, "".concat(_this49.uniqueId, " .morning-text"), 'chars');
    _this49.morningTextSplit = new Array(_this49.morningTextSplit);
    _this49.dayTextSplit = _get((_thisSuper4 = _assertThisInitialized(_this49), _getPrototypeOf(AnimatedGradientCarousel.prototype)), "textSplitter", _thisSuper4).call(_thisSuper4, "".concat(_this49.uniqueId, " .day-text"), 'chars');
    _this49.dayTextSplit = new Array(_this49.dayTextSplit);
    _this49.nightTextSplit = _get((_thisSuper5 = _assertThisInitialized(_this49), _getPrototypeOf(AnimatedGradientCarousel.prototype)), "textSplitter", _thisSuper5).call(_thisSuper5, "".concat(_this49.uniqueId, " .night-text"), 'chars');
    _this49.nightTextSplit = new Array(_this49.nightTextSplit);
    ScrollSmoother.create({
      smooth: 1.7,
      smoothTouch: 0.1
    });
    _this49.options = {
      morningColor: _this49.dataset.colorOne,
      dayColor: _this49.dataset.colorTwo,
      nightColor: _this49.dataset.colorThree,
      positions: _this49.positions,
      endTrigger: "#".concat(_this49.nextSection),
      gradientTarget: "".concat(_this49.uniqueId, " animated-gradient-carousel"),
      positionTargets: _this49.positionTargets,
      morningText: _this49.morningTextSplit,
      dayText: _this49.dayTextSplit,
      nightText: _this49.nightTextSplit,
      morningIcon: "".concat(_this49.uniqueId, " animated-gradient-carousel .icon-daypart .morning path"),
      dayIcon: "".concat(_this49.uniqueId, " animated-gradient-carousel .icon-daypart .midday path"),
      nightIcon: "".concat(_this49.uniqueId, " animated-gradient-carousel .icon-daypart .evening path"),
      sunriseIcon: "".concat(_this49.querySelector('#sunrise').getAttribute('d')),
      sunshineIcon: "".concat(_this49.querySelector('#sunshine').getAttribute('d')),
      moonIcon: "".concat(_this49.querySelector('#moon').getAttribute('d'))
    };
    window.addEventListener('resize', function () {
      _this49.positions = _this49.getPositions(window.innerWidth);
      _this49.options.positions = _this49.positions;
    });
    _this49.setScrollTrigger("".concat(_this49.uniqueId, " .pin"), _this49.options);
    return _this49;
  }
  _createClass(AnimatedGradientCarousel, [{
    key: "assessNextSection",
    value: function assessNextSection(uniqueId) {
      var immediateNextSection = document.querySelector(uniqueId).nextElementSibling;
      if (immediateNextSection.querySelector('a')) {
        if (immediateNextSection.querySelector('a').classList.contains('anchor')) {
          return immediateNextSection.nextElementSibling.getAttribute('id');
        } else {
          return document.querySelector(uniqueId).nextElementSibling.getAttribute('id');
        }
      } else {
        return document.querySelector(uniqueId).nextElementSibling.getAttribute('id');
      }
    }
  }, {
    key: "getPositions",
    value: function getPositions(windowWidth) {
      if (windowWidth < Shopify.breakpoints.mobile) {
        return {
          positionOne: {
            top: '70px',
            right: '0px',
            scale: '1.5'
          },
          positionTwo: {
            top: '-70px',
            right: '-90px',
            scale: '1'
          },
          positionThree: {
            top: '-70px',
            right: '100px',
            scale: '1'
          }
        };
      } else if (windowWidth < Shopify.breakpoints.tablet) {
        return {
          positionOne: {
            top: '70px',
            right: '0px',
            scale: '1.5'
          },
          positionTwo: {
            top: '-150px',
            right: '-200px',
            scale: '1'
          },
          positionThree: {
            top: '-100px',
            right: '200px',
            scale: '1'
          }
        };
      } else if (windowWidth < Shopify.breakpoints.desktop) {
        return {
          positionOne: {
            top: '40px',
            right: '20px',
            scale: '1'
          },
          positionTwo: {
            top: '-150px',
            right: '-200px',
            scale: '0.5'
          },
          positionThree: {
            top: '-200px',
            right: '200px',
            scale: '0.5'
          }
        };
      } else {
        // Positions for ultra-wide viewports
        return {
          positionOne: {
            top: '40px',
            right: '20px',
            scale: '1'
          },
          positionTwo: {
            top: '-150px',
            right: '-200px',
            scale: '0.5'
          },
          positionThree: {
            top: '-200px',
            right: '200px',
            scale: '0.5'
          }
        };
      }
    }
  }, {
    key: "getPositionTargets",
    value: function getPositionTargets(uniqueId) {
      return {
        morningTarget: "".concat(uniqueId, " .carousel-position--1"),
        dayTarget: "".concat(uniqueId, " .carousel-position--2"),
        nightTarget: "".concat(uniqueId, " .carousel-position--3")
      };
    }
  }, {
    key: "setScrollTrigger",
    value: function setScrollTrigger(triggerSelector, options) {
      var gradientTl = gsap.timeline({
        scrollTrigger: {
          trigger: triggerSelector,
          start: 'top top',
          end: 'bottom bottom',
          endTrigger: options.endTrigger,
          pin: true,
          scrub: 8
        }
      });
      var fadeIn = gsap.set('.carousel-container', {
        y: '10%',
        opacity: '0.0'
      });
      gsap.to('.carousel-container', {
        scrollTrigger: {
          trigger: triggerSelector,
          start: '-20% 60%',
          end: "-20% 20%",
          scrub: true
        },
        y: '0%',
        opacity: '1.0'
      });
      gradientTl.to(options.gradientTarget, {
        backgroundImage: "linear-gradient(0deg, ".concat(options.dayColor, " 0%, ").concat(options.morningColor, " 33%, ").concat(options.morningColor, " 66%, ").concat(options.morningColor, " 100%)"),
        duration: 1
      }, ">").to(options.morningText, {
        y: '0%',
        opacity: '1.0',
        stagger: 0.2,
        duration: 2
      }, "<+0.5").to(options.gradientTarget, {
        backgroundImage: "linear-gradient(0deg, ".concat(options.dayColor, " 0%, ").concat(options.dayColor, " 33%, ").concat(options.morningColor, " 66%, ").concat(options.morningColor, " 100%)"),
        duration: 2
      }, ">+5").to(options.morningText, {
        y: '-100%',
        stagger: 0.2,
        duration: 6
      }, ">").to(options.morningText, {
        opacity: '0.0',
        stagger: 0.2,
        duration: 6
      }, "<+0.1").to(options.positionTargets.nightTarget, {
        top: options.positions.positionTwo.top,
        right: options.positions.positionTwo.right,
        scale: options.positions.positionTwo.scale,
        zIndex: "1",
        duration: 6
      }, "<").to(options.positionTargets.morningTarget, {
        top: options.positions.positionThree.top,
        right: options.positions.positionThree.right,
        scale: options.positions.positionThree.scale,
        zIndex: "1",
        duration: 6
      }, "<").to(options.morningIcon, {
        rotation: 180,
        opacity: 0.0,
        transformOrigin: 'center bottom',
        duration: 6
      }, "<").to("#sunrise", {
        attr: {
          d: options.sunshineIcon
        },
        duration: 2
      }, "<").to(options.positionTargets.dayTarget, {
        top: options.positions.positionOne.top,
        right: options.positions.positionOne.right,
        scale: options.positions.positionOne.scale,
        zIndex: "2",
        duration: 6
      }, "<").from(options.dayIcon, {
        rotation: -180,
        opacity: 0.0,
        transformOrigin: 'center bottom',
        duration: 6
      }, "<").to(options.gradientTarget, {
        backgroundImage: "linear-gradient(0deg, ".concat(options.dayColor, " 0%, ").concat(options.dayColor, " 33%, ").concat(options.dayColor, " 66%, ").concat(options.dayColor, " 100%)"),
        duration: 2
      }, ">").to(options.dayText, {
        y: '0%',
        opacity: '1.0',
        stagger: 0.2,
        duration: 6
      }, "<").to(options.gradientTarget, {
        backgroundImage: "linear-gradient(0deg, ".concat(options.nightColor, " 0%, ").concat(options.dayColor, " 33%, ").concat(options.dayColor, " 66%, ").concat(options.dayColor, " 100%)"),
        duration: 1
      }, ">+9").to(options.gradientTarget, {
        backgroundImage: "linear-gradient(0deg, ".concat(options.nightColor, " 0%, ").concat(options.nightColor, " 33%, ").concat(options.nightColor, " 66%, ").concat(options.nightColor, " 100%)"),
        duration: 2
      }, ">").to(options.positionTargets.nightTarget, {
        top: options.positions.positionOne.top,
        right: options.positions.positionOne.right,
        scale: options.positions.positionOne.scale,
        zIndex: "2",
        duration: 6
      }, "<").to(options.positionTargets.morningTarget, {
        top: options.positions.positionTwo.top,
        right: options.positions.positionTwo.right,
        scale: options.positions.positionTwo.scale,
        zIndex: "1",
        duration: 6
      }, "<").to(options.dayIcon, {
        rotation: 180,
        opacity: 0.0,
        transformOrigin: 'center bottom',
        duration: 6
      }, "<").to("#sunrise", {
        attr: {
          d: options.moonIcon
        },
        duration: 2
      }, "<").to(options.positionTargets.dayTarget, {
        top: options.positions.positionThree.top,
        right: options.positions.positionThree.right,
        scale: options.positions.positionThree.scale,
        zIndex: "1",
        duration: 6
      }, "<").from(options.nightIcon, {
        rotation: -180,
        opacity: 0.0,
        transformOrigin: 'center bottom',
        duration: 6
      }, "<").to(options.dayText, {
        y: '-100%',
        opacity: '0.0',
        stagger: 0.2,
        duration: 3
      }, "<").to(options.nightText, {
        y: '0%',
        opacity: '1.0',
        stagger: 0.2,
        duration: 6
      }, "<").to('.carousel-container', {
        opacity: '0',
        duration: 6
      }, ">+6");
    }
  }]);
  return AnimatedGradientCarousel;
}(AnimatedTextContainer);
customElements.define('animated-gradient-carousel', AnimatedGradientCarousel);
var CountdownTimer = /*#__PURE__*/function (_HTMLElement21) {
  _inherits(CountdownTimer, _HTMLElement21);
  var _super29 = _createSuper(CountdownTimer);
  function CountdownTimer() {
    var _this50;
    _classCallCheck(this, CountdownTimer);
    _this50 = _super29.call(this);
    _this50.expirationDayAsString = _this50.dataset.expDate != null ? _this50.dataset.expDate : null;
    _this50.expirationTimeAsString = _this50.dataset.expTime != null ? _this50.dataset.expTime : null;
    var expirationAsString = _this50.formatDateString(_this50.expirationDayAsString, _this50.expirationTimeAsString);
    _this50.second = 1000;
    _this50.minute = _this50.second * 60;
    _this50.hour = _this50.minute * 60;
    _this50.day = _this50.hour * 24;
    _this50.countDownFire(expirationAsString);
    return _this50;
  }

  /* This method takes the inputs from theme settings, validates and formats them for Date Objects them */
  _createClass(CountdownTimer, [{
    key: "formatDateString",
    value: function formatDateString(expDate, expTime) {
      /* RegEx to validate time format correctly in HH:MM, otherwise returns null */
      if (expTime.match(/^[0-2][0-9]:[0-5][0-9]/)) {
        if (expTime[0] > 1) {
          if (expTime[1] > 4) {
            /* fallback fires if HH exceeds 23, also returns null */
            this.fireFallBack();
            return null;
          }
        }
        /* re-format date from UK DD/MM/YYYY to YYYY/MM/DD for Date String */
        var expDateArr = expDate.split('/');
        var formattedDate = "".concat(expDateArr[2], "-").concat(expDateArr[1], "-").concat(expDateArr[0]);
        /* Construct Date String */
        var dateString = "".concat(formattedDate, "T").concat(expTime);
        return dateString;
      } else {
        return null;
      }
    }
  }, {
    key: "countDownFire",
    value: function countDownFire(expirationAsString) {
      var _this51 = this;
      /* providing formatDateString didn't return null, countdown interval is fired */
      if (expirationAsString != null) {
        var countingInterval = setInterval(function () {
          var expObj = new Date(expirationAsString).getTime();
          var now = new Date().getTime();
          var timeDiff = expObj - now;
          expObj = expObj - 1000;
          if (timeDiff < 1) {
            /* when countdown hits 0, kill interval, fire fallback method */
            clearInterval(countingInterval);
            _this51.fireFallBack();
          } else {
            _this51.calcAndPrintCount(timeDiff);
          }
        }, this.second);
      } else {
        this.fireFallBack();
      }
    }
  }, {
    key: "calcAndPrintCount",
    value: function calcAndPrintCount(timeDiff) {
      /* method for updating countdown timer on the front end, hides zero'd denominations (i.e instead of "0 days 22 h 18m 10s" it will hide "0 days") */
      var daysLeft = Math.floor(timeDiff / this.day);
      this.querySelector(':scope .days-remaining').innerText = daysLeft;
      if (daysLeft == 1) {
        this.querySelector(':scope .day-string').style.display = 'inline';
        this.querySelector(':scope .days-string').style.display = 'none';
      } else if (daysLeft < 1) {
        this.querySelector(':scope .days-remaining').style.display = 'none';
        this.querySelector(':scope .day-string').style.display = 'none';
        this.querySelector(':scope .days-string').style.display = 'none';
      } else if (daysLeft > 1) {
        this.querySelector(':scope .days-string').style.display = 'inline';
        this.querySelector(':scope .day-string').style.display = 'none';
      }
      if (Math.floor(timeDiff % this.day / this.hour) >= 1) {
        this.querySelector(':scope .hours-remaining').innerText = Math.floor(timeDiff % this.day / this.hour);
        this.querySelector(':scope .hours-wrapper').style.display = 'inline';
      } else {
        this.querySelector(':scope .hours-wrapper').style.display = 'none';
      }
      if (Math.floor(timeDiff % this.hour / this.minute) >= 1) {
        this.querySelector(':scope .minutes-remaining').innerText = Math.floor(timeDiff % this.hour / this.minute);
        this.querySelector(':scope .mins-wrapper').style.display = 'inline';
      } else {
        this.querySelector(':scope .mins-wrapper').style.display = 'none';
      }
      if (Math.floor(timeDiff % this.minute / this.second) >= 1) {
        this.querySelector(':scope .seconds-remaining').innerText = Math.floor(timeDiff % this.minute / this.second);
        this.querySelector(':scope .secs-wrapper').style.display = 'inline';
      } else {
        this.querySelector(':scope .secs-wrapper').style.display = 'none';
      }
    }
  }, {
    key: "fireFallBack",
    value: function fireFallBack() {
      /* swaps the displayed element for the fallback message instead of the timer */
      this.querySelector(':scope .active-timer').style.display = 'none';
      this.querySelector(':scope .inactive-timer').style.display = 'block';
    }
  }]);
  return CountdownTimer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('countdown-timer', CountdownTimer);
var VisualFilter = /*#__PURE__*/function (_HTMLElement22) {
  _inherits(VisualFilter, _HTMLElement22);
  var _super30 = _createSuper(VisualFilter);
  /* This class has a combination of static and instance based properties
  ||
  || STATIC PROPERTIES
  || searchParams
  || filteredLineupEvent
  ||
  || STATIC METHODS
  || updateUrlHash()
  || clearListener()
  ||
  || The static methods & properties are set up as static due to VisualFilter
  || having multiple instances per page, and these properties & methods should be shared
  || I hope this comment helps guide future developers. */

  function VisualFilter() {
    var _this52;
    _classCallCheck(this, VisualFilter);
    _this52 = _super30.call(this);
    _this52.filterValue = _this52.dataset.filterValue;
    _this52.paramString = "filter.p.m.filter.visual_filter_".concat(_this52.dataset.filterType);
    _this52.currentGrid = document.querySelector('#Product-Grid');
    _this52.updateActiveClasses(new URLSearchParams(window.location.search));
    _this52.visualFilterApplied = _this52.classList.contains('visual-filter-active') ? true : false;
    _this52.setListeners();
    return _this52;
  }
  _createClass(VisualFilter, [{
    key: "setListeners",
    value: function setListeners() {
      this.addEventListener('click', this.handleVisualFilter.bind(this));
      document.addEventListener('visualFilterHook', this.handleClassicFacets.bind(this));
    }
  }, {
    key: "handleVisualFilter",
    value: function () {
      var _handleVisualFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (this.visualFilterApplied === true) {
                  VisualFilter.clearVisualFilters();
                  this.visualFilterApplied = false;
                  this.classList.remove('visual-filter-active');
                  document.querySelector('#clearVisualFilters') ? document.querySelector('#clearVisualFilters').classList.add('hidden') : null;
                  this.dispatchEvent(VisualFilter.filteredLineupEvent, 'filtered-lineup');
                  this.renderPage();
                } else {
                  VisualFilter.clearVisualFilters();
                  VisualFilter.searchParams.append(this.paramString, this.filterValue);
                  this.visualFilterApplied = true;
                  this.classList.add('visual-filter-active');
                  document.querySelector('#clearVisualFilters') ? document.querySelector('#clearVisualFilters').classList.remove('hidden') : null;
                  this.dispatchEvent(VisualFilter.filteredLineupEvent, 'filtered-lineup');
                  this.renderPage();
                }
              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
      function handleVisualFilter() {
        return _handleVisualFilter.apply(this, arguments);
      }
      return handleVisualFilter;
    }()
  }, {
    key: "handleClassicFacets",
    value: function handleClassicFacets() {
      VisualFilter.searchParams = new URLSearchParams(window.location.search);
    }
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var url, gridHtml, orignalGrid, filteredGrid, sectionId, selector, oldGrid;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
                VisualFilter.searchParams["delete"]('page');
                orignalGrid = "main-collection-product-grid-".concat(FacetFiltersForm.gridType);
                filteredGrid = FacetFiltersForm.gridType === 'bulk' ? 'main-collection-product-grid-bulk' : 'main-collection-product-grid-standard';
                sectionId = VisualFilter.searchParams.size > 0 ? "".concat(filteredGrid) : "".concat(orignalGrid);
                url = "".concat(window.location.origin).concat(window.location.pathname, "?section_id=").concat(sectionId).concat(VisualFilter.searchParams.size > 0 ? "&" + VisualFilter.searchParams.toString() : '');
                selector = document.querySelector('#ProductGridContainer .collection.page-width') ? '#ProductGridContainer .collection.page-width' : '#ProductGridContainer';
                _context13.next = 9;
                return this.fetchPageAndParse(url, selector, sectionId);
              case 9:
                gridHtml = _context13.sent;
                oldGrid = document.querySelector('#ProductGridContainer .collection.page-width') ? document.querySelector('#ProductGridContainer .collection.page-width') : document.querySelector('#ProductGridContainer');
                oldGrid.innerHTML = gridHtml.innerHTML;
                customizerObj.refreshCustomizationInDom();
                document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
                VisualFilter.updateUrlHash();
              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
      function renderPage() {
        return _renderPage.apply(this, arguments);
      }
      return renderPage;
    }()
  }, {
    key: "fetchPageAndParse",
    value: function () {
      var _fetchPageAndParse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(url, selector, section) {
        var gridHtml;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return fetch(url).then(function (response) {
                  return response.text();
                }).then(function (responseText) {
                  var html = responseText;
                  var gridAsHtml = new DOMParser().parseFromString(html, 'text/html');
                  gridAsHtml = gridAsHtml.querySelector(selector);
                  return gridAsHtml;
                });
              case 2:
                gridHtml = _context14.sent;
                return _context14.abrupt("return", gridHtml);
              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));
      function fetchPageAndParse(_x8, _x9, _x10) {
        return _fetchPageAndParse.apply(this, arguments);
      }
      return fetchPageAndParse;
    }()
  }, {
    key: "updateActiveClasses",
    value: function updateActiveClasses(searchParams) {
      if (searchParams.has(this.paramString, this.filterValue)) {
        this.classList.add('visual-filter-active');
      } else {
        this.classList.remove('visual-filter-active');
      }
    }
  }], [{
    key: "updateUrlHash",
    value: function updateUrlHash() {
      if (window.history.state !== null) {
        if (window.history.state !== "".concat(VisualFilter.searchParams.size ? '?' + VisualFilter.searchParams : '')) {
          window.history.pushState("".concat(VisualFilter.searchParams.size ? '?' + VisualFilter.searchParams : ''), '', "".concat(window.location.pathname).concat(VisualFilter.searchParams.size ? '?' + VisualFilter.searchParams : ''));
        } else {}
      } else {
        window.history.pushState("".concat(VisualFilter.searchParams.size ? '?' + VisualFilter.searchParams : ''), '', "".concat(window.location.pathname).concat(VisualFilter.searchParams.size ? '?' + VisualFilter.searchParams : ''));
      }
    }
  }, {
    key: "clearListener",
    value: function clearListener() {
      if (document.querySelector('#clearVisualFilters')) {
        document.querySelector('#clearVisualFilters').addEventListener('click', function () {
          document.querySelector('#clearVisualFilters').classList.add('hidden');
          VisualFilter.clearVisualFilters();
          document.querySelector('visual-filter').dispatchEvent(VisualFilter.filteredLineupEvent, 'filtered-lineup');
          document.querySelector('visual-filter').renderPage();
        });
      }
      VisualFilter.updateUrlHash();
    }
  }, {
    key: "clearVisualFilters",
    value: function clearVisualFilters(event) {
      document.querySelectorAll('visual-filter').forEach(function (filter, index) {
        VisualFilter.searchParams["delete"](filter.paramString);
        if (filter.classList.contains('visual-filter-active')) {
          filter.classList.remove('visual-filter-active');
        }
        filter.visualFilterApplied = false;
      });
      document.querySelector('filtered-lineup') ? document.querySelector('filtered-lineup').toggle = false : null;
      document.querySelector('visual-filter').dispatchEvent(VisualFilter.filteredLineupEvent, 'filtered-lineup');
    }
  }]);
  return VisualFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
_defineProperty(VisualFilter, "filteredLineupEvent", new Event('filtered-lineup'));
_defineProperty(VisualFilter, "searchParams", new URLSearchParams(window.location.search));
_defineProperty(VisualFilter, "paginationRegex", /page=.*&/);
customElements.define('visual-filter', VisualFilter);
VisualFilter.clearListener();
var ColourSibling = /*#__PURE__*/function (_HTMLElement23) {
  _inherits(ColourSibling, _HTMLElement23);
  var _super31 = _createSuper(ColourSibling);
  function ColourSibling() {
    var _this53;
    _classCallCheck(this, ColourSibling);
    _this53 = _super31.call(this);
    _this53.usage = _this53.dataset.usage;
    if (_this53.usage == 'quick-add') {
      _this53.defineProps();
      _this53.defineElems();
      _this53.defineEvents();
      _this53.setListeners();
      _this53.currentVariantId = _this53.querySelector('input[checked]') ? _this53.querySelector('input[checked]').dataset.v : null;
    }
    return _this53;
  }
  _createClass(ColourSibling, [{
    key: "defineElems",
    value: function defineElems() {
      var _this54 = this;
      if (this.usage == 'quick-add') {
        this.relevantCard = this.closest(this.usage);
      }
      this.fieldSets = this.querySelectorAll('.product-form__input_color');
      this.colourInputs = this.querySelectorAll('.product-form__variant-input');
      this.liElems = this.querySelectorAll('.thumbnail-list__item');
      this.cardMedia = this.relevantCard.querySelector('.quick-add-card__image');
      this.selectedColor = this.relevantCard.querySelector('[data-product-selected-color]');
      this.atcId = this.relevantCard.querySelector('input[name="id"]');
      this.customizeButton = this.relevantCard.querySelector('.product-customize-btn');
      this.cardLinks = [];
      this.relevantCard.querySelectorAll('a').forEach(function (a) {
        if (!a.classList.contains('product-customize-btn' || 'quick-add__atc--bis')) {
          _this54.cardLinks.push(a);
        }
      });
      // Acquire ATC element for updating ATC status on colour sibling click
      this.mainProductWrapper = this.closest('quick-add').querySelector('.quick-add__inner');
      this.mainProductContainer = this.closest('quick-add').querySelector('.quick-add__content');
      this.inputs = this.querySelectorAll('input[type="radio"]');
      if (this.mainProductContainer) {
        var _this$mainProductCont;
        this.productForm = this.mainProductContainer.querySelector('product-form');
        this.atcBtn = this.productForm.querySelector('[id^="AddToCart-"]');
        this.signInToBuyBtn = (_this$mainProductCont = this.mainProductContainer) === null || _this$mainProductCont === void 0 ? void 0 : _this$mainProductCont.querySelector('sign-in-to-buy');
        this.atcId = this.productForm.querySelector('input[name="id"]');
        this.price = this.mainProductContainer.querySelector('.price-item--regular');
        this.salePrice = this.mainProductContainer.querySelector('.price__sale .price-item--sale') ? this.salePrice = this.mainProductContainer.querySelector('.price__sale .price-item--sale') : null;
      }
    }
  }, {
    key: "defineEvents",
    value: function defineEvents() {
      this.quickAddColourChangeEvt = new Event('quick-add-colour-change-cust');
      this.quickAddColourChangeKlaviyoBISEvt = new Event('quick-add-colour-change-klav');
      this.toggleCustomizeEvt = new Event('toggle-customizer-button');
      if (!this.offShelfCust) {
        this.dispatchEvent(this.toggleCustomizeEvt, 'toggle-customizer-button');
      }
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this55 = this;
      this.liElems.forEach(function (li) {
        return li.addEventListener('click', _this55.handleChange.bind(_this55));
      });
    }
  }, {
    key: "defineProps",
    value: function () {
      var _defineProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.colourData = JSON.parse(this.querySelector('.json__colour_siblings').innerText);
                this.offShelfCust = this.closest('quick-add').dataset.offShelfCust === 'true' ? true : false;
                this.offShelfGalleryHandle = this.closest('quick-add').dataset.offShelfGalleryHandle;
                _context15.next = 5;
                return this.setCurrentlySelected();
              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
      function defineProps() {
        return _defineProps.apply(this, arguments);
      }
      return defineProps;
    }()
  }, {
    key: "handleChange",
    value: function () {
      var _handleChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var prevColourData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.colourInputs.forEach( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(input) {
                    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            input.removeAttribute('checked');
                          case 1:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16);
                  }));
                  return function (_x11) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              case 2:
                _context17.next = 4;
                return event.currentTarget.querySelector('input').setAttribute('checked', '');
              case 4:
                prevColourData = this.currentColourData;
                _context17.next = 7;
                return this.setCurrentlySelected();
              case 7:
                if (!(this.offShelfCust === true)) {
                  _context17.next = 12;
                  break;
                }
                _context17.next = 10;
                return this.toggleOffShelf(this.currentColourData, this.offShelfGalleryHandle, prevColourData);
              case 10:
                _context17.next = 21;
                break;
              case 12:
                _context17.next = 14;
                return this.colourUpdate(this.currentColourData);
              case 14:
                _context17.next = 16;
                return this.updateATCButton(this.currentColourData);
              case 16:
                _context17.next = 18;
                return this.updateBadges(this.currentColourData);
              case 18:
                this.dispatchEvent(this.quickAddColourChangeEvt, 'quick-add-colour-change-cust');
                this.dispatchEvent(this.quickAddColourChangeKlaviyoBISEvt, 'quick-add-colour-change-klav');
                this.dispatchEvent(this.toggleCustomizeEvt, 'toggle-customizer-button');
              case 21:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
      function handleChange() {
        return _handleChange.apply(this, arguments);
      }
      return handleChange;
    }()
  }, {
    key: "handleOffshelfParams",
    value: function handleOffshelfParams(currentColourData, prevColourData) {
      var oldUrl = this.cardLinks[0].href;
      var prevParams = oldUrl.split('?')[1];
      prevParams = new URLSearchParams(prevParams);
      if (prevParams !== undefined) {
        if (Boolean(prevParams.get('off-shelf-cust'))) {
          var _prevColourData$cust_, _currentColourData$cu, _currentColourData$cu2;
          var newUrl = oldUrl.replace("".concat(prevColourData.product_handle), "".concat(currentColourData.product_handle));
          newUrl = newUrl.replace("".concat(prevColourData === null || prevColourData === void 0 ? void 0 : (_prevColourData$cust_ = prevColourData.cust_data) === null || _prevColourData$cust_ === void 0 ? void 0 : _prevColourData$cust_.customizer_upk), "".concat(currentColourData === null || currentColourData === void 0 ? void 0 : (_currentColourData$cu = currentColourData.cust_data) === null || _currentColourData$cu === void 0 ? void 0 : _currentColourData$cu.customizer_upk));
          var params = new URLSearchParams(newUrl);
          var oldSku = params.get('sku');
          newUrl = newUrl.replace("".concat(oldSku), "".concat(currentColourData === null || currentColourData === void 0 ? void 0 : (_currentColourData$cu2 = currentColourData.cust_data) === null || _currentColourData$cu2 === void 0 ? void 0 : _currentColourData$cu2.variant_sku));
          this.cardLinks.forEach(function (link) {
            return link.href = newUrl;
          });
        } else {
          var _currentColourData$cu3, _currentColourData$cu4;
          var _newUrl = oldUrl.replace("".concat(prevColourData.product_handle), "".concat(currentColourData.product_handle));
          var _params = this.relevantCard.querySelector('off-shelf-atc').params;
          _params.set('product-key', "".concat(currentColourData === null || currentColourData === void 0 ? void 0 : (_currentColourData$cu3 = currentColourData.cust_data) === null || _currentColourData$cu3 === void 0 ? void 0 : _currentColourData$cu3.customizer_upk));
          _params.set('sku', "".concat(currentColourData === null || currentColourData === void 0 ? void 0 : (_currentColourData$cu4 = currentColourData.cust_data) === null || _currentColourData$cu4 === void 0 ? void 0 : _currentColourData$cu4.variant_sku));
          _newUrl = _newUrl + '?' + _params.toString();
          this.cardLinks.forEach(function (link) {
            return link.href = _newUrl;
          });
        }
      }
    }
  }, {
    key: "toggleOffShelf",
    value: function () {
      var _toggleOffShelf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(currentColourData, selectedOffShelf, prevColourData) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(JSON.stringify(currentColourData) === JSON.stringify(prevColourData))) {
                  _context18.next = 2;
                  break;
                }
                return _context18.abrupt("return");
              case 2:
                if (!(currentColourData.cust_data.off_shelf_images[selectedOffShelf] !== undefined && (currentColourData === null || currentColourData === void 0 ? void 0 : currentColourData.customizer_upk) !== '')) {
                  _context18.next = 14;
                  break;
                }
                this.offShelfAtc = this.relevantCard.querySelector('off-shelf-atc');
                !this.cardMedia.classList.contains('customized-prepared') ? this.cardMedia.classList.add('customized-prepared') : null;
                this.updateOffShelfImg(currentColourData.cust_data.off_shelf_images[selectedOffShelf]);
                this.handleOffshelfParams(currentColourData, prevColourData);
                this.offShelfAtc.dataset.productUpk = currentColourData.cust_data.customizer_upk;
                this.offShelfAtc.setCustomAttributes();
                this.atcBtn.style.display = 'none';
                this.offShelfAtc.style.display = 'inline';
                this.atcId.value = currentColourData.variantId;
                _context18.next = 28;
                break;
              case 14:
                this.offShelfAtc = this.relevantCard.querySelector('off-shelf-atc') !== undefined ? this.relevantCard.querySelector('off-shelf-atc') : null;
                if (this.offShelfAtc !== null && this.offShelfAtc.imageListenersSet === true) {
                  this.relevantCard.querySelector('.product__media').removeEventListener('mouseenter', this.offShelfAtc.setSecondImage);
                  this.relevantCard.querySelector('.product__media').removeEventListener('mouseleave', this.offShelfAtc.setOriginalImage);
                  this.offShelfAtc.imageListenersSet = false;
                }
                this.atcBtn.style.display = 'inline';
                this.relevantCard.querySelector('off-shelf-atc').style.display = 'none';
                this.cardMedia.classList.remove('customized-prepared');
                _context18.next = 21;
                return this.colourUpdate(this.currentColourData);
              case 21:
                _context18.next = 23;
                return this.updateATCButton(this.currentColourData);
              case 23:
                _context18.next = 25;
                return this.updateBadges(this.currentColourData);
              case 25:
                this.dispatchEvent(this.quickAddColourChangeEvt, 'quick-add-colour-change-cust');
                this.dispatchEvent(this.quickAddColourChangeKlaviyoBISEvt, 'quick-add-colour-change-klav');
                this.dispatchEvent(this.toggleCustomizeEvt, 'toggle-customizer-button');
              case 28:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
      function toggleOffShelf(_x12, _x13, _x14) {
        return _toggleOffShelf.apply(this, arguments);
      }
      return toggleOffShelf;
    }()
  }, {
    key: "updateOffShelfImg",
    value: function updateOffShelfImg(offShelfImageUrl) {
      this.cardMedia.src = "".concat(offShelfImageUrl);
      this.cardMedia.srcset = "".concat(offShelfImageUrl);
      this.closest('quick-add').querySelector('.product-customize-btn').style.visibility = "hidden";
    }
  }, {
    key: "updateATCButton",
    value: function () {
      var _updateATCButton = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(selectedColourData) {
        var isEarlyAccessProduct;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                isEarlyAccessProduct = (selectedColourData === null || selectedColourData === void 0 ? void 0 : selectedColourData.is_early_access_product) === "true";
                if (isEarlyAccessProduct && !window.isCustomerLoggedIn && selectedColourData.available) {
                  this.signInToBuyBtn ? this.signInToBuyBtn.classList.remove("hidden") : null;
                  this.atcBtn ? this.atcBtn.classList.add("hidden") : null;
                  this.customizeButton ? this.customizeButton.classList.add("disabled") : null;
                  this.customizeButton ? this.customizeButton.setAttribute("disabled", "disabled") : null;
                } else {
                  this.signInToBuyBtn ? this.signInToBuyBtn.classList.add("hidden") : null;
                  this.atcBtn ? this.atcBtn.classList.remove("hidden") : null;
                  this.customizeButton ? this.customizeButton.classList.remove("disabled") : null;
                  this.customizeButton ? this.customizeButton.removeAttribute("disabled") : null;
                }
                if (selectedColourData.available == 'true') {
                  this.mainProductContainer ? this.mainProductContainer.querySelector('.price').classList.remove('price--sold-out') : null;
                  this.mainProductContainer ? this.mainProductContainer.querySelector('.price').classList.add('price--in-stock') : null;
                  this.atcBtn ? this.atcBtn.querySelector('span').innerText = window.variantStrings.addToCart : null;
                  this.atcBtn ? this.atcBtn.removeAttribute('disabled') : null;
                } else {
                  this.mainProductContainer ? this.mainProductContainer.querySelector('.price').classList.remove('price--in-stock') : null;
                  this.mainProductContainer ? this.mainProductContainer.querySelector('.price').classList.add('price--sold-out') : null;
                  this.atcBtn ? this.atcBtn.querySelector('span').innerText = window.variantStrings.soldOut : null;
                  this.atcBtn ? this.atcBtn.setAttribute('disabled', '') : null;
                  this.atcBtn ? this.atcBtn.classList.remove("hidden") : null;
                  this.signInToBuyBtn ? this.signInToBuyBtn.classList.add("hidden") : null;
                }
              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
      function updateATCButton(_x15) {
        return _updateATCButton.apply(this, arguments);
      }
      return updateATCButton;
    }()
  }, {
    key: "updateBadges",
    value: function () {
      var _updateBadges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(selectedColourData) {
        var _selectedColourData$c2;
        var badgesComponent, badgeContainer, badge, _selectedColourData$c;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                badgesComponent = this.mainProductWrapper.querySelector('.card-info-badges');
                if (badgesComponent) {
                  _context20.next = 3;
                  break;
                }
                return _context20.abrupt("return");
              case 3:
                badgeContainer = badgesComponent.querySelector('.product__badges');
                if (badgeContainer) {
                  _context20.next = 6;
                  break;
                }
                return _context20.abrupt("return");
              case 6:
                badge = badgeContainer.querySelector('.badge');
                if (!badge) {
                  badge = document.createElement('span');
                  badge.classList.add('badge');
                  badge.innerHTML = selectedColourData === null || selectedColourData === void 0 ? void 0 : (_selectedColourData$c = selectedColourData.cust_data) === null || _selectedColourData$c === void 0 ? void 0 : _selectedColourData$c.badge;
                  badgeContainer.append(badge);
                }
                if (!((_selectedColourData$c2 = selectedColourData.cust_data) !== null && _selectedColourData$c2 !== void 0 && _selectedColourData$c2.badge)) {
                  badge.style.display = 'none';
                } else {
                  badge.innerText = selectedColourData.cust_data.badge;
                  badge.setAttribute('data-variant', selectedColourData === null || selectedColourData === void 0 ? void 0 : selectedColourData.product_title);
                  badge.style.display = 'inline-block';
                }
              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
      function updateBadges(_x16) {
        return _updateBadges.apply(this, arguments);
      }
      return updateBadges;
    }()
  }, {
    key: "colourUpdate",
    value: function () {
      var _colourUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(selectedColourData) {
        var signInLink;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.dataset.productId = selectedColourData.productId;
                // call method to handle product card colour sibling selection on products with size variants
                if (this.usage == 'quick-add' && selectedColourData.variants.length > 1) {
                  this.updateVariantPicker(selectedColourData.product_handle);
                }
                this.dataset.customizerUpk = selectedColourData.customizer_upk;
                this.querySelector('input[checked]') ? this.querySelector('input[checked]').dataset.v = selectedColourData.variantId : null;
                this.cardLinks.forEach(function (link) {
                  return link.href = selectedColourData.product_url;
                });
                if (this.signInToBuyBtn) {
                  signInLink = this.signInToBuyBtn.querySelector('a');
                  if (signInLink) {
                    signInLink.href = '/customer_authentication/login?return_to=' + encodeURIComponent(selectedColourData.product_url);
                  }
                }
                this.cardMedia.src = "".concat(selectedColourData.featured_media, "&width=345");
                this.cardMedia.srcset = "".concat(selectedColourData.featured_media, "&width=345");
                //If product does not have vairant of size, do not update ATC ID, as this is handled by variant picker
                if (selectedColourData.variants.length <= 1) {
                  this.atcId.value = selectedColourData.variantId;
                }
                if (this.selectedColor) {
                  _context21.next = 11;
                  break;
                }
                return _context21.abrupt("return");
              case 11:
                this.selectedColor.textContent = selectedColourData.variants[0].variant_title;
              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
      function colourUpdate(_x17) {
        return _colourUpdate.apply(this, arguments);
      }
      return colourUpdate;
    }()
  }, {
    key: "setCurrentlySelected",
    value: function () {
      var _setCurrentlySelected = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this56 = this;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.currentVariantId = this.querySelector('input[checked]') ? this.querySelector('input[checked]').dataset.v : null;
                _context22.next = 3;
                return this.colourData.find(function (colour) {
                  return colour.variantId === _this56.currentVariantId;
                });
              case 3:
                this.currentColourData = _context22.sent;
              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));
      function setCurrentlySelected() {
        return _setCurrentlySelected.apply(this, arguments);
      }
      return setCurrentlySelected;
    }()
  }, {
    key: "updateVariantPicker",
    value: function () {
      var _updateVariantPicker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(handle) {
        var variantPickerElem, newVp, parser, html;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                variantPickerElem = this.relevantCard.querySelector('variant-picker');
                _context23.next = 3;
                return fetch("/products/".concat(handle, "?section_id=section-variant-picker"), {
                  method: "GET"
                });
              case 3:
                newVp = _context23.sent;
                _context23.next = 6;
                return newVp.text();
              case 6:
                newVp = _context23.sent;
                parser = new DOMParser();
                html = parser.parseFromString(newVp, 'text/html');
                newVp = html.querySelector('variant-picker').outerHTML;
                variantPickerElem.outerHTML = newVp;
              case 11:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
      function updateVariantPicker(_x18) {
        return _updateVariantPicker.apply(this, arguments);
      }
      return updateVariantPicker;
    }()
  }]);
  return ColourSibling;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('colour-sibling', ColourSibling);
var VariantPicker = /*#__PURE__*/function (_HTMLElement24) {
  _inherits(VariantPicker, _HTMLElement24);
  var _super32 = _createSuper(VariantPicker);
  function VariantPicker() {
    var _this57;
    _classCallCheck(this, VariantPicker);
    _this57 = _super32.call(this);
    _this57.usage = _this57.dataset.usage;
    if (window.sessionStorage.getItem('selectedVariantValue') != undefined) {
      _this57.selectedValue = window.sessionStorage.getItem('selectedVariantValue');
    } else {
      _this57.selectedValue = _this57.dataset.selectedValue;
    }
    _this57.defineProps();
    _this57.defineElements();
    _this57.setListeners();
    _this57.handleVariantChange(null, false);
    return _this57;
  }
  _createClass(VariantPicker, [{
    key: "defineElements",
    value: function defineElements() {
      this.fieldset = this.querySelector('fieldset');
      this.inputs = this.querySelectorAll('input[type="radio"]');
      if (this.usage == 'main-product') {
        this.mainProductContainer = this.closest('.product__info-container') ? this.closest('.product__info-container') : null;
        if (this.mainProductContainer) {
          this.productForm = this.mainProductContainer.querySelector('product-form');
          this.atcBtn = this.productForm.querySelector('[id^="AddToCart-"]');
          this.atcId = this.productForm.querySelector('input[name="id"]');
          this.price = this.mainProductContainer.querySelector('.price-item--regular');
          this.salePrice = this.mainProductContainer.querySelector('.price__sale .price-item--sale') ? this.salePrice = this.mainProductContainer.querySelector('.price__sale .price-item--sale') : null;
          this.variantOption = this.mainProductContainer.querySelector('.product-atc__options') ? this.mainProductContainer.querySelector('.product-atc__options') : null;
          this.productAtc = this.mainProductContainer.querySelector('product-atc');
        }
      }
      if (this.usage == 'quick-add') {
        this.quickAddContainer = this.closest('.quick-add__content') ? this.closest('.quick-add__content') : null;
        if (this.quickAddContainer) {
          this.productForm = this.quickAddContainer.querySelector('product-form');
          this.atcBtn = this.quickAddContainer.querySelector('[id^="AddToCart-"]');
          this.atcId = this.quickAddContainer.querySelector('input[name="id"]');
          this.price = this.quickAddContainer.querySelector('.price-item--regular');
          this.salePrice = this.quickAddContainer.querySelector('.price__sale .price-item--sale') ? this.salePrice = this.quickAddContainer.querySelector('.price__sale .price-item--sale') : null;
        }
      }
    }
  }, {
    key: "defineProps",
    value: function defineProps() {
      var _this58 = this;
      this.variantData = this.querySelector('.product__variant--data') ? JSON.parse(this.querySelector('.product__variant--data').innerText) : null;
      this.selectedVariantData = this.variantData.find(function (variant) {
        return variant.option_value.toLowerCase() == _this58.selectedValue.toLowerCase();
      });
      this.variantQueryString = '?variant=';
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this59 = this;
      this.inputs.forEach(function (input) {
        return input.addEventListener('click', _this59.handleVariantChange.bind(_this59));
      });
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(e) {
      var _this60 = this;
      var triggeredByEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // updates checked attribute for newly selected variant
      this.inputs.forEach(function (input) {
        return input.removeAttribute('checked');
      });
      triggeredByEvent === true ? e.currentTarget.setAttribute('checked', '') : this.querySelector("input[type=\"radio\"][value=\"".concat(this.selectedValue, "\"]")).setAttribute('checked', '');
      // Uses value from checked variant input to grab variant data from JSON object
      this.selectedValue = Array.from(this.inputs).find(function (input) {
        return input.hasAttribute('checked');
      }).value;
      this.selectedVariantData = this.variantData.find(function (variant) {
        return variant.option_value.toLowerCase() == _this60.selectedValue.toLowerCase();
      });

      // Updates price to match variants price and handle sale conditions
      this.price.innerText = "".concat(Shopify.formatMoney(this.selectedVariantData.variant_price, Shopify.moneyFormat), " ").concat(document.querySelector('#_int').dataset.currencyCode);
      if (this.salePrice != null) {
        this.price.innerText = "".concat(Shopify.formatMoney(this.selectedVariantData.variant_price, Shopify.moneyFormat), " ").concat(document.querySelector('#_int').dataset.currencyCode);
        this.salePrice.innerText = "".concat(Shopify.formatMoney(this.selectedVariantData.variant_compare_at_price, Shopify.moneyFormat), " ").concat(document.querySelector('#_int').dataset.currencyCode);
      }
      // Updates atc ID for correct variant and pushes variant ID Query string to window history
      this.atcId.value = this.selectedVariantData.variantId;
      if (this.usage == 'main-product') {
        history.pushState({
          variantId: this.selectedVariantData.variantId
        }, '', "".concat(this.variantQueryString).concat(this.selectedVariantData.variantId));
      }
      // Updates atc Variant Options
      if (this.usage == 'main-product' && this.variantOption !== null) {
        var _this$selectedVariant;
        this.variantOption.innerText = (_this$selectedVariant = this.selectedVariantData) === null || _this$selectedVariant === void 0 ? void 0 : _this$selectedVariant.variant_title;
      }

      // Updates ATC button and badges based on stock availability
      if (this.usage == 'main-product') {
        var _this$selectedVariant2;
        if (this.selectedVariantData.available == 'true') {
          this.mainProductContainer.querySelector('.price').classList.remove('price--sold-out');
          this.mainProductContainer.querySelector('.price').classList.add('price--in-stock');
          this.atcBtn.innerHTML = "<span class=\"add-to-bag\">".concat(window.variantStrings.addToCart, "</span>");
          this.atcBtn.removeAttribute('disabled');
        } else {
          this.mainProductContainer.querySelector('.price').classList.remove('price--in-stock');
          this.mainProductContainer.querySelector('.price').classList.add('price--sold-out');
          this.atcBtn.innerHTML = "<span class=\"add-to-bag\">".concat(window.variantStrings.soldOut, "</span>");
          this.atcBtn.setAttribute('disabled', '');
        }
        this.productAtc.querySelector('.product-atc-initial-price').dataset.price = (_this$selectedVariant2 = this.selectedVariantData) === null || _this$selectedVariant2 === void 0 ? void 0 : _this$selectedVariant2.variant_price;
        this.productAtc.defineProps();
        this.productAtc.calculateProductATCPrice();
      }
      if (this.usage == 'quick-add') {
        if (this.selectedVariantData.available == 'true') {
          this.quickAddContainer.querySelector('.price').classList.remove('price--sold-out');
          this.quickAddContainer.querySelector('.price').classList.add('price--in-stock');
          this.atcBtn.innerHTML = "<span>".concat(window.variantStrings.addToCart, "</span>");
          this.atcBtn.removeAttribute('disabled');
        } else {
          this.quickAddContainer.querySelector('.price').classList.remove('price--in-stock');
          this.quickAddContainer.querySelector('.price').classList.add('price--sold-out');
          this.atcBtn.innerHTML = "<span>".concat(window.variantStrings.soldOut, "</span>");
          this.atcBtn.setAttribute('disabled', '');
        }
      }

      // Stores selected option value in sessionStorage to reload selected variant on sibling change
      window.sessionStorage.setItem('selectedVariantValue', this.selectedValue);
    }
  }]);
  return VariantPicker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('variant-picker', VariantPicker);
var KlaviyoContainer = /*#__PURE__*/function (_HTMLElement25) {
  _inherits(KlaviyoContainer, _HTMLElement25);
  var _super33 = _createSuper(KlaviyoContainer);
  function KlaviyoContainer() {
    var _this61;
    _classCallCheck(this, KlaviyoContainer);
    _this61 = _super33.call(this);
    _this61.product = _this61.dataset.product;
    _this61.productHandle = _this61.dataset.productHandle;
    _this61.associatedColourSibling;
    if (_this61.dataset.usage === 'main-product') {
      _this61.associatedColourSibling = _this61.closest('.product__info-container').querySelector('colour-sibling');
    } else if (_this61.dataset.usage === 'quick-add') {
      _this61.associatedColourSibling = _this61.closest('quick-add').querySelector('colour-sibling');
    } else {
      _this61.associatedColourSibling = null;
    }
    _this61.associatedATC = _this61.querySelector("#AddToCart--".concat(_this61.product));
    _this61.klaviyoButtonContainer = _this61.querySelector("#klaviyo-button-container--".concat(_this61.product));
    _this61.klaviyoButton = _this61.querySelector('.klaviyo-product-container');
    _this61.hideSignInToBuy = _this61.dataset.hideSitb === 'true';
    if (_this61.associatedColourSibling) _this61.associatedColourSibling.addEventListener('quick-add-colour-change-klav', function () {
      _this61.handleVariantChange(event);
    });
    _this61.waitForKlaviyo();
    return _this61;
  }
  _createClass(KlaviyoContainer, [{
    key: "waitForKlaviyo",
    value: function waitForKlaviyo() {
      var attempts = 0;
      function klaviyoChecker() {
        return _klaviyoChecker.apply(this, arguments);
      }
      function _klaviyoChecker() {
        _klaviyoChecker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
          return _regeneratorRuntime().wrap(function _callee24$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  if (_typeof(window.klaviyoBIS) === 'object' || attempts > 10) {
                    this.trigger = this.querySelector('.klaviyo-bis-trigger');
                    this.klaviyoButtonContainer.style.removeProperty('position');
                    if (!this.trigger) this.insertButton();
                    if (this.usage === 'main-product') {
                      // The following code ensure the erroneous automatic placement of Klaviyo BIS next to the payment terms is removed.
                      this.priceAssociatedBISButton = this.closest('.product__info-container').querySelector('.product__price-stars-wrapper');
                      if (this.priceAssociatedBISButton.querySelectorAll('.klaviyo-bis-trigger').length > 0) {
                        this.priceAssociatedBISButton.querySelectorAll('.button.button--full-width.button--primary').forEach(function (bisButton) {
                          bisButton.remove();
                        });
                      }
                    }
                    clearInterval(interval);
                    this.handleVariantChange();
                    if (!this.hideSignInToBuy) {
                      this.associatedATC.classList.add('hidden');
                      this.klaviyoButtonContainer.classList.add('hidden');
                    }
                  }
                  attempts++;
                case 2:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee24, this);
        }));
        return _klaviyoChecker.apply(this, arguments);
      }
      var interval = setInterval(klaviyoChecker.bind(this), 100);
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(event) {
      var _event$target;
      //if method fired from user colour change event, update attributes of klaviyo 再入荷通知を受け取る button elements with new product data
      var selectedColourData = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.currentColourData;
      var isEarlyAccessProduct = (selectedColourData === null || selectedColourData === void 0 ? void 0 : selectedColourData.is_early_access_product) === "true";
      if (event) {
        this.klaviyoButton.id = "klaviyo-data-handle-".concat(event.target.currentColourData.product_handle);
        this.klaviyoButton.dataset.klaviyoHandle = event.target.currentColourData.product_handle;
        this.klaviyoButtonInner = this.klaviyoButton.querySelector('.klaviyo-button-container');
        this.klaviyoButtonInner.id = "klaviyo-button-container--".concat(event.target.currentColourData.productId);
        this.klaviyoButtonInner.querySelector(".klaviyo-bis-trigger").dataset.klaviyoHandle = event.target.currentColourData.product_handle;
      }
      if (this.associatedATC.hasAttribute('disabled') && document.querySelector('product-bundle') === null) {
        this.associatedATC.classList.add('hidden');
        this.klaviyoButtonContainer.classList.remove('hidden');
        if (this.dataset.usage === 'quick-add' && this.klaviyoButtonContainer.querySelector('a') === null) {
          this.insertButton();
        }
      } else {
        if (isEarlyAccessProduct && !window.isCustomerLoggedIn && selectedColourData !== null && selectedColourData !== void 0 && selectedColourData.available) {
          this.associatedATC.classList.add('hidden');
          this.klaviyoButtonContainer.classList.add('hidden');
        } else {
          this.associatedATC.classList.remove('hidden');
          this.klaviyoButtonContainer.classList.add('hidden');
        }
      }
    }
  }, {
    key: "insertButton",
    value: function insertButton() {
      var parser = new DOMParser();
      var newKlaviyoBisButton;
      if (this.dataset.usage === 'quick-add' && this.klaviyoButtonContainer.querySelector('a') === null) {
        newKlaviyoBisButton = parser.parseFromString('<a class="quick-add__atc--bis klaviyo-bis-trigger" href="#" style="padding: inherit; text-align: left;" data-klaviyo-handle="">再入荷通知を受け取る</a>', 'text/html').querySelector('a');
        newKlaviyoBisButton.dataset.klaviyoHandle = this.productHandle;
        this.klaviyoButtonContainer.insertAdjacentHTML('afterbegin', newKlaviyoBisButton.outerHTML);
      } else {
        newKlaviyoBisButton = parser.parseFromString('<a class="button button--full-width button--secondary klaviyo-bis-trigger" data-klaviyo-handle="" href="#" style="text-align: center; margin: 0px; width: auto;">再入荷通知を受け取る</a>', 'text/html').querySelector('a');
        newKlaviyoBisButton.dataset.klaviyoHandle = this.productHandle;
        this.klaviyoButtonContainer.insertAdjacentHTML('afterbegin', newKlaviyoBisButton.outerHTML);
      }
    }
  }]);
  return KlaviyoContainer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('klaviyo-container', KlaviyoContainer);
var FilteredLineup = /*#__PURE__*/function (_HTMLElement26) {
  _inherits(FilteredLineup, _HTMLElement26);
  var _super34 = _createSuper(FilteredLineup);
  function FilteredLineup() {
    var _this62;
    _classCallCheck(this, FilteredLineup);
    _this62 = _super34.call(this);
    _this62.visualFilters = document.querySelectorAll('visual-filter');
    _this62.wrapper = _this62.closest('.filtered-lineup__wrapper');
    _this62.toggle = _this62.wrapper.classList.contains('.filtered-lineup__show') ? false : true;
    _this62.paramString = 'filter.p.m.filter.visual_filter_tile';
    _this62.productDataArray = [];
    _this62.defaultProductblock = _this62.wrapper.querySelector('.grid__item');
    _this62.domCache = window.sessionStorage.getItem('filtered-lineup-cache') !== null ? JSON.parse(window.sessionStorage.getItem('filtered-lineup-cache')) : [];
    _this62.domParser = new DOMParser();
    _this62.handleRefresh();
    _this62.setEventListeners();
    _this62.sliderCache = _this62.querySelector('.progress-slider') ? _this62.querySelector('.progress-slider').outerHTML : null;
    _this62.colourTypes = _this62.dataset.productsWithColour.split(',');
    _this62.pickColour = _this62.dataset.pickColour;
    return _this62;
  }
  _createClass(FilteredLineup, [{
    key: "handleRefresh",
    value: function handleRefresh() {
      var params = new URLSearchParams(window.location.href.split('?')[1]);
      if (params.has(this.paramString)) {
        var appliedFilter = params.get(this.paramString);
        var cachedDom = this.checkCacheForLineup(appliedFilter);
        cachedDom !== undefined ? this.renderFromCache(cachedDom) : this.renderFromFetch(appliedFilter);
        var visualFilterJson = document.querySelector("visual-filter[data-filter-value=\"".concat(appliedFilter, "\"] .product_lineup_json")) ? JSON.parse(document.querySelector("visual-filter[data-filter-value=\"".concat(appliedFilter, "\"] .product_lineup_json")).innerText) : null;
        this.handleTitles(visualFilterJson.title, visualFilterJson.subtitle);
        this.toggle = true;
        this.toggleLineup(this.toggle);
      }
    }
  }, {
    key: "renderFromFetch",
    value: function () {
      var _renderFromFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(appliedFilter) {
        var visualFilterJson, allDataFetched;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                visualFilterJson = JSON.parse(document.querySelector("visual-filter[data-filter-value=\"".concat(appliedFilter, "\"] .product_lineup_json")).innerText);
                _context25.next = 3;
                return this.accumulateLineupData(visualFilterJson.handles);
              case 3:
                this.handleTitles(visualFilterJson.title, visualFilterJson.subtitle);
                _context25.next = 6;
                return Promise.all(this.promiseArray);
              case 6:
                allDataFetched = _context25.sent;
                if (allDataFetched) {
                  this.productDataArray = this.productDataArray.filter(function (data) {
                    return data !== undefined;
                  });
                  this.productDataArray.sort(this.arrayComparisonFunction);
                  this.cloneProductBlocks(this.productDataArray);
                  this.populateProductData(this.productDataArray, appliedFilter);
                  this.toggle = true;
                  this.toggleLineup(this.toggle);
                }
              case 8:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));
      function renderFromFetch(_x19) {
        return _renderFromFetch.apply(this, arguments);
      }
      return renderFromFetch;
    }()
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this63 = this;
      this.visualFilters.forEach(function (vf) {
        vf.addEventListener('filtered-lineup', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
          var visualFilterJson, currentVfValue, cachedDom, allDataFetched;
          return _regeneratorRuntime().wrap(function _callee26$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  if (!event.currentTarget.classList.contains('visual-filter-active')) {
                    _context26.next = 22;
                    break;
                  }
                  visualFilterJson = event.currentTarget.querySelector('.product_lineup_json') ? JSON.parse(event.currentTarget.querySelector('.product_lineup_json').innerText) : null;
                  if (!(visualFilterJson === null)) {
                    _context26.next = 4;
                    break;
                  }
                  return _context26.abrupt("return");
                case 4:
                  currentVfValue = event.currentTarget.dataset.filterValue;
                  cachedDom = _this63.checkCacheForLineup(currentVfValue);
                  if (!(cachedDom !== undefined)) {
                    _context26.next = 13;
                    break;
                  }
                  _this63.handleTitles(visualFilterJson.title, visualFilterJson.subtitle);
                  _this63.renderFromCache(cachedDom);
                  _this63.toggle = true;
                  _this63.toggleLineup(_this63.toggle);
                  _context26.next = 20;
                  break;
                case 13:
                  _context26.next = 15;
                  return _this63.accumulateLineupData(visualFilterJson.handles);
                case 15:
                  _this63.handleTitles(visualFilterJson.title, visualFilterJson.subtitle);
                  _context26.next = 18;
                  return Promise.all(_this63.promiseArray);
                case 18:
                  allDataFetched = _context26.sent;
                  if (allDataFetched) {
                    _this63.productDataArray = _this63.productDataArray.filter(function (data) {
                      return data !== undefined;
                    });
                    _this63.productDataArray.sort(_this63.arrayComparisonFunction);
                    _this63.cloneProductBlocks(_this63.productDataArray);
                    _this63.populateProductData(_this63.productDataArray, currentVfValue);
                    _this63.toggleLineup(_this63.toggle);
                  }
                case 20:
                  _context26.next = 24;
                  break;
                case 22:
                  _this63.toggle = false;
                  _this63.toggleLineup(_this63.toggle);
                case 24:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee26);
        })));
      });
    }
  }, {
    key: "arrayComparisonFunction",
    value: function arrayComparisonFunction(a, b) {
      if (a.index < b.index) {
        return -1;
      }
      if (a.index > b.index) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "handleTitles",
    value: function handleTitles(title, subtitle) {
      document.querySelector('.title-wrapper h2').innerText = title;
      document.querySelector('.title-wrapper .subtitle').innerText = subtitle;
    }
  }, {
    key: "accumulateLineupData",
    value: function () {
      var _accumulateLineupData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(handles) {
        var _this64 = this;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                this.promiseArray = [];
                _context28.next = 3;
                return handles.forEach(function (handle, index) {
                  var productDataPromise = new Promise( /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(resolve, reject) {
                      return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                        while (1) {
                          switch (_context27.prev = _context27.next) {
                            case 0:
                              _context27.t0 = _this64.productDataArray;
                              _context27.next = 3;
                              return _this64.fetchProductData(handle.trim(), index);
                            case 3:
                              _context27.t1 = _context27.sent;
                              _context27.t0.push.call(_context27.t0, _context27.t1);
                              resolve();
                            case 6:
                            case "end":
                              return _context27.stop();
                          }
                        }
                      }, _callee27);
                    }));
                    return function (_x21, _x22) {
                      return _ref6.apply(this, arguments);
                    };
                  }());
                  _this64.promiseArray.push(productDataPromise);
                });
              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
      function accumulateLineupData(_x20) {
        return _accumulateLineupData.apply(this, arguments);
      }
      return accumulateLineupData;
    }()
  }, {
    key: "cloneProductBlocks",
    value: function cloneProductBlocks(productDataArray) {
      var _this65 = this;
      this.productBlockArray = [];
      productDataArray.forEach(function (product) {
        _this65.productBlockArray.push(_this65.defaultProductblock.cloneNode(true));
      });
      var sliderWrapper = this.wrapper.querySelector('slider-component ul.product-grid');
      var existingBlocks = this.wrapper.querySelectorAll('.grid__item');
      existingBlocks.forEach(function (block) {
        block.remove();
      });
      productDataArray.forEach(function (product, index) {
        sliderWrapper.append(_this65.productBlockArray[index]);
      });
      sliderWrapper.querySelectorAll('.grid__item').forEach(function (item, index) {
        item.setAttribute('data-block-index', index + 1);
      });
    }
  }, {
    key: "setTitle",
    value: function setTitle(productBlock, productDataArray, index) {
      var _productDataArray$ind, _productDataArray$ind2;
      // Set Title
      productBlock.querySelector('.product-data__title').innerText = (_productDataArray$ind = productDataArray[index]) === null || _productDataArray$ind === void 0 ? void 0 : _productDataArray$ind.product_title;
      productBlock.querySelector('.product-data__title').closest('a').href = "".concat(window.location.pathname, "/products/").concat((_productDataArray$ind2 = productDataArray[index]) === null || _productDataArray$ind2 === void 0 ? void 0 : _productDataArray$ind2.handle);
    }
  }, {
    key: "setImage",
    value: function setImage(productBlock, productDataArray, index) {
      if (productDataArray[index].cropped_image === '') {
        var _productDataArray$ind3, _productDataArray$ind4, _productDataArray$ind5;
        productBlock.querySelector('.multicolumn-card > div').innerHTML = "<a href=\"".concat(window.location.pathname, "/products/").concat((_productDataArray$ind3 = productDataArray[index]) === null || _productDataArray$ind3 === void 0 ? void 0 : _productDataArray$ind3.handle, "\" class=\"media product__media\"><img src=\"").concat((_productDataArray$ind4 = productDataArray[index]) === null || _productDataArray$ind4 === void 0 ? void 0 : _productDataArray$ind4.meta_image, "\" alt=\"\" class=\"filtered-lineup__media\" /></a>");
        productBlock.querySelector('.media.product__media').style.paddingTop = "".concat(1 / ((_productDataArray$ind5 = productDataArray[index]) === null || _productDataArray$ind5 === void 0 ? void 0 : _productDataArray$ind5.main_aspect) * 100, "%");
      } else {
        var _productDataArray$ind6, _productDataArray$ind7, _productDataArray$ind8;
        productBlock.querySelector('.multicolumn-card > div').innerHTML = "<a href=\"".concat(window.location.pathname, "/products/").concat((_productDataArray$ind6 = productDataArray[index]) === null || _productDataArray$ind6 === void 0 ? void 0 : _productDataArray$ind6.handle, "\" class=\"media product__media\"><img src=\"").concat((_productDataArray$ind7 = productDataArray[index]) === null || _productDataArray$ind7 === void 0 ? void 0 : _productDataArray$ind7.cropped_image, "\" alt=\"\" class=\"filtered-lineup__media cropped\" /></a>");
        productBlock.querySelector('.media.product__media').style.paddingTop = "".concat(1 / ((_productDataArray$ind8 = productDataArray[index]) === null || _productDataArray$ind8 === void 0 ? void 0 : _productDataArray$ind8.cropped_aspect) * 100, "%");
      }
    }
  }, {
    key: "setAdditionalData",
    value: function setAdditionalData(productBlock, productDataArray, index) {
      var _productDataArray$ind9, _productDataArray$ind10, _productDataArray$ind11, _productDataArray$ind12, _productDataArray$ind13, _productDataArray$ind14, _productDataArray$ind17, _productDataArray$ind18, _productDataArray$ind19, _productDataArray$ind20, _productDataArray$ind21, _productDataArray$ind22;
      (_productDataArray$ind9 = productDataArray[index]) !== null && _productDataArray$ind9 !== void 0 && (_productDataArray$ind10 = _productDataArray$ind9.meta_main) !== null && _productDataArray$ind10 !== void 0 && _productDataArray$ind10.external_dimensions ? productBlock.querySelector('.product-data__dimensions').innerText = (_productDataArray$ind11 = productDataArray[index]) === null || _productDataArray$ind11 === void 0 ? void 0 : (_productDataArray$ind12 = _productDataArray$ind11.meta_main) === null || _productDataArray$ind12 === void 0 ? void 0 : _productDataArray$ind12.external_dimensions : null;
      // If Compare beer/ice set, otherwise clear
      if (((_productDataArray$ind13 = productDataArray[index]) === null || _productDataArray$ind13 === void 0 ? void 0 : (_productDataArray$ind14 = _productDataArray$ind13.meta_main) === null || _productDataArray$ind14 === void 0 ? void 0 : _productDataArray$ind14.compare_beer) !== undefined || '') {
        var _productDataArray$ind15, _productDataArray$ind16;
        productBlock.querySelector('.product-data__additional--col-1 .product-data__additional-value').innerText = (_productDataArray$ind15 = productDataArray[index]) === null || _productDataArray$ind15 === void 0 ? void 0 : (_productDataArray$ind16 = _productDataArray$ind15.meta_main) === null || _productDataArray$ind16 === void 0 ? void 0 : _productDataArray$ind16.compare_beer;
        productBlock.querySelector('.product-data__additional--col-1 .product-data__additional-unit').innerText = "".concat(this.dataset.canUnit);
      } else {
        productBlock.querySelector('.product-data__additional--col-1 .product-data__additional-value').innerText = '';
        productBlock.querySelector('.product-data__additional--col-1 .product-data__additional-unit').innerText = '';
      }
      if (((_productDataArray$ind17 = productDataArray[index]) === null || _productDataArray$ind17 === void 0 ? void 0 : (_productDataArray$ind18 = _productDataArray$ind17.meta_main) === null || _productDataArray$ind18 === void 0 ? void 0 : _productDataArray$ind18.compare_ice) !== undefined || '' && ((_productDataArray$ind19 = productDataArray[index]) === null || _productDataArray$ind19 === void 0 ? void 0 : (_productDataArray$ind20 = _productDataArray$ind19.meta_main) === null || _productDataArray$ind20 === void 0 ? void 0 : _productDataArray$ind20.compare_beer) !== undefined || '') {
        productBlock.querySelector('.product-data__additional--col-2 .product-data__additional-operator').innerText = "".concat(this.dataset.operator);
      } else {
        productBlock.querySelector('.product-data__additional--col-2 .product-data__additional-operator').innerText = '';
      }
      if (((_productDataArray$ind21 = productDataArray[index]) === null || _productDataArray$ind21 === void 0 ? void 0 : (_productDataArray$ind22 = _productDataArray$ind21.meta_main) === null || _productDataArray$ind22 === void 0 ? void 0 : _productDataArray$ind22.compare_ice) !== undefined || '') {
        var _productDataArray$ind23, _productDataArray$ind24;
        productBlock.querySelector('.product-data__additional--col-3 .product-data__additional-value').innerText = (_productDataArray$ind23 = productDataArray[index]) === null || _productDataArray$ind23 === void 0 ? void 0 : (_productDataArray$ind24 = _productDataArray$ind23.meta_main) === null || _productDataArray$ind24 === void 0 ? void 0 : _productDataArray$ind24.compare_ice;
        productBlock.querySelector('.product-data__additional--col-3 .product-data__additional-unit').innerText = "".concat(this.dataset.iceUnit);
      } else {
        productBlock.querySelector('.product-data__additional--col-3 .product-data__additional-value').innerText = '';
        productBlock.querySelector('.product-data__additional--col-3 .product-data__additional-unit').innerText = '';
      }
    }
  }, {
    key: "setLinks",
    value: function setLinks(productBlock, productDataArray, index) {
      if (this.colourTypes.find(function (productType) {
        var _productDataArray$ind25;
        return productType === ((_productDataArray$ind25 = productDataArray[index]) === null || _productDataArray$ind25 === void 0 ? void 0 : _productDataArray$ind25.product_type);
      }) !== undefined) {
        var _productDataArray$ind26;
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').innerText = this.pickColour;
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').href = "".concat(window.location.pathname, "/products/").concat((_productDataArray$ind26 = productDataArray[index]) === null || _productDataArray$ind26 === void 0 ? void 0 : _productDataArray$ind26.handle);
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').classList.remove('hide');
      } else {
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').innerText = '';
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').href = "";
        productBlock.querySelector('.product-data__link a.filtered-lineup__link').classList.add('hide');
      }
    }
  }, {
    key: "populateProductData",
    value: function populateProductData(productDataArray, vfValue) {
      var _this66 = this;
      this.productBlockArray.forEach(function (productBlock, index) {
        _this66.setTitle(productBlock, productDataArray, index);
        _this66.setImage(productBlock, productDataArray, index);
        _this66.setAdditionalData(productBlock, productDataArray, index);
        _this66.setLinks(productBlock, productDataArray, index);
      });
      this.cacheLineupData(vfValue);
      this.productDataArray = [];
      this.setDesktopJustify(productDataArray.length);
    }
  }, {
    key: "fetchProductData",
    value: function () {
      var _fetchProductData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(handle, index) {
        var productData, returnedProductData;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return fetch("/products/".concat(handle, "?view=view_meta"));
              case 2:
                productData = _context29.sent;
                if (!productData.ok) {
                  _context29.next = 14;
                  break;
                }
                _context29.next = 6;
                return productData.json();
              case 6:
                returnedProductData = _context29.sent;
                returnedProductData.product_title = returnedProductData.product_title.replaceAll('&quot;', '"');
                returnedProductData.meta_subtitle = returnedProductData.meta_subtitle.replaceAll('&quot;', '"');
                returnedProductData.product_type = returnedProductData.product_type.replaceAll('&quot;', '"');
                returnedProductData.index = index;
                return _context29.abrupt("return", returnedProductData);
              case 14:
                return _context29.abrupt("return");
              case 15:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));
      function fetchProductData(_x23, _x24) {
        return _fetchProductData.apply(this, arguments);
      }
      return fetchProductData;
    }()
  }, {
    key: "renderFromCache",
    value: function renderFromCache(cachedDom) {
      var newLineup = this.domParser.parseFromString(cachedDom === null || cachedDom === void 0 ? void 0 : cachedDom.dom, 'text/html');
      this.querySelector('.product-grid.slider').outerHTML = newLineup.querySelector('.product-grid.slider').outerHTML;
      this.setDesktopJustify(this.querySelectorAll('.multicolumn-card').length);
    }
  }, {
    key: "cacheLineupData",
    value: function cacheLineupData(vfValue) {
      var cacheObject = {
        "value": "".concat(vfValue),
        "dom": this.querySelector('.product-grid.slider').outerHTML
      };
      this.domCache.push(cacheObject);
      window.sessionStorage.setItem('filtered-lineup-cache', JSON.stringify(this.domCache));
    }
  }, {
    key: "checkCacheForLineup",
    value: function checkCacheForLineup(vfValue) {
      // query cache for lineup here, otherwise return undefined
      var foundCache = this.domCache.find(function (dom) {
        return (dom === null || dom === void 0 ? void 0 : dom.value) === vfValue;
      });
      return foundCache;
    }
  }, {
    key: "toggleLineup",
    value: function toggleLineup(toggle) {
      // toggle is a boolean, true == show lineup, false == hide lineup
      if (toggle) {
        this.wrapper.classList.remove('filtered-lineup--hide');
        this.wrapper.classList.add('filtered-lineup--show');
        this.sliderNeeded();
        this.handleProgressSlider();
        this.toggle = false;
      } else {
        this.wrapper.classList.remove('filtered-lineup--show');
        this.wrapper.classList.add('filtered-lineup--hide');
        this.toggle = true;
      }
    }
  }, {
    key: "sliderNeeded",
    value: function sliderNeeded() {
      if (window.innerWidth > Shopify.breakpoints.tablet) {
        this.maxCardsPerView = 4;
      } else if (window.innerWidth < Shopify.breakpoints.tablet && window.innerWidth > Shopify.breakpoints.mobile) {
        this.maxCardsPerView = 3;
      } else {
        this.maxCardsPerView = 2;
      }
      if (this.querySelector('.progress-slider')) {
        return;
      } else {
        this.querySelector('.slider__wrapper').innerHTML = this.sliderCache;
      }
    }
  }, {
    key: "handleProgressSlider",
    value: function handleProgressSlider() {
      if (this.querySelectorAll('.slider__slide').length > 2) {
        this.querySelector('slider-component').reInit();
      } else {
        this.querySelector('.progress-slider') ? this.querySelector('.progress-slider').remove() : null;
      }
    }
  }, {
    key: "setDesktopJustify",
    value: function setDesktopJustify(numberOfLineupItems) {
      if (numberOfLineupItems <= 3) {
        this.querySelector(".product-grid").classList.add('filtered-lineup-list__centered');
      } else {
        this.querySelector(".product-grid").classList.remove('filtered-lineup-list__centered');
      }
    }
  }]);
  return FilteredLineup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('filtered-lineup', FilteredLineup);
var SectionTracker = /*#__PURE__*/function (_HTMLElement27) {
  _inherits(SectionTracker, _HTMLElement27);
  var _super35 = _createSuper(SectionTracker);
  function SectionTracker() {
    var _this67;
    _classCallCheck(this, SectionTracker);
    _this67 = _super35.call(this);
    _this67.defineProps();
    _this67.setListener(_this67.sectionRootElem, 'click');
    return _this67;
  }
  _createClass(SectionTracker, [{
    key: "defineProps",
    value: function defineProps() {
      this.customElemTracking = this.dataset.trackCustomChildren === "true" ? true : false;
      this.sectionName = this.dataset.sectionName;
      this.sectionIndex = this.dataset.sectionIndex;
      this.pageName = this.dataset.pageName;
      this.pageType = this.dataset.pageType;
      this.customTarget = this.closest('.shopify-section').querySelector("".concat(this.dataset.eventTarget));
      this.sectionRootElem = this.customTarget != null ? this.customTarget : this.closest(".shopify-section");
      this.navEvent = this.dataset.navEvent;
    }
  }, {
    key: "buildTrackingObject",
    value: function buildTrackingObject(event) {
      if (event.target.closest('[data-block-index]') !== null) {
        this.blockIndex = event.target.closest('[data-block-index]').dataset.blockIndex;
      } else {
        this.blockIndex = null;
      }
      if (this.blockIndex !== null) {
        this.checkForAssets(event.target);
        this.checkForLinks(event.target);
        this.checkDisplayVersion();
        var trackingObj = {
          "event_type": "".concat(event.type),
          "page_type": "".concat(this.pageType),
          "page_name": "".concat(this.pageName),
          "section_name": "".concat(this.sectionName),
          "event_index": "".concat(this.sectionIndex, ".").concat(this.blockIndex === null ? '?' : this.blockIndex),
          "display_version": "".concat(this.displayVersion)
        };
        this.linkPresent === true ? trackingObj.destination_url = "".concat(this.destinationUrl) : null;
        this.assetPresent === true ? trackingObj.asset_url = "".concat(this.interactedAsset) : null;
        return trackingObj;
      } else {
        return null;
      }
    }
  }, {
    key: "buildNavTrackingObject",
    value: function buildNavTrackingObject(event) {
      if (event.target.closest('[data-block-index]') !== null) {
        this.blockIndex = event.target.closest('[data-block-index]').dataset.blockIndex;
      } else {
        this.blockIndex = null;
      }
      if (this.blockIndex !== null) {
        var _parentWrapper$queryS, _parentWrapper$queryS2;
        this.checkForAssets(event.target);
        this.checkForLinks(event.target);
        this.checkDisplayVersion();
        var parentWrapper = event.target.closest('details.mega-menu') !== undefined ? event.target.closest('details.mega-menu') : null;

        // Initialize variables to store link titles
        var grandchildlinkTitle = null;
        var childlinkTitle = null;
        var parentTitle = null;

        // Get parent title from mega menu
        if (parentWrapper !== null && parentWrapper !== void 0 && (_parentWrapper$queryS = parentWrapper.querySelector('a[data-parent-title]')) !== null && _parentWrapper$queryS !== void 0 && (_parentWrapper$queryS2 = _parentWrapper$queryS.dataset) !== null && _parentWrapper$queryS2 !== void 0 && _parentWrapper$queryS2.parentTitle) {
          parentTitle = parentWrapper.querySelector('a[data-parent-title]').dataset.parentTitle;
        }

        // Check if the clicked element is a grandchild link
        var grandchildLink = event.target.closest('a[data-grandchildlink-title]');

        // Check if the clicked element is a child link
        var childLink = event.target.closest('a[data-childlink-title]');

        // If a grandchild link was clicked
        if (grandchildLink) {
          var _event$target$closest, _childTitleElement$da;
          // Store the grandchild link title
          grandchildlinkTitle = grandchildLink.dataset.grandchildlinkTitle;

          // Try to find the child title by navigating to the previous sibling of the grandchild's parent UL
          var childTitleElement = (_event$target$closest = event.target.closest('ul.mega-menu__link--level-3')) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.previousElementSibling;
          childlinkTitle = (childTitleElement === null || childTitleElement === void 0 ? void 0 : (_childTitleElement$da = childTitleElement.dataset) === null || _childTitleElement$da === void 0 ? void 0 : _childTitleElement$da.childlinkTitle) || null;
        }

        // If no grandchild link was clicked but a child link was clicked
        if (!grandchildLink && childLink) {
          // Store the child link title
          childlinkTitle = childLink.dataset.childlinkTitle;
        }
        var topHeaderLink = event.target.closest('a').dataset.headerTitle !== undefined ? event.target.closest('a').dataset.headerTitle : null;
        var trackingObj = {
          "event_type": "navigation_click",
          "page_type": "".concat(this.pageType),
          "page_name": "".concat(this.pageName),
          "section_name": "".concat(this.sectionName),
          "event_index": "".concat(this.sectionIndex, ".").concat(this.blockIndex === null ? '?' : this.blockIndex),
          "display_version": "".concat(this.displayVersion),
          "primary_header": parentTitle,
          "secondary_header": childlinkTitle,
          "click_text": grandchildlinkTitle,
          "programmatic_link_bar": topHeaderLink
        };
        this.linkPresent === true ? trackingObj.destination_url = "".concat(this.destinationUrl) : null;
        this.assetPresent === true ? trackingObj.asset_url = "".concat(this.interactedAsset) : null;
        return trackingObj;
      } else {
        return null;
      }
    }
  }, {
    key: "checkDisplayVersion",
    value: function checkDisplayVersion() {
      if (window.innerWidth > 989) {
        this.displayVersion = "desktop";
      } else if (window.innerWidth >= 749) {
        this.displayVersion = "tablet";
      } else {
        this.displayVersion = "mobile";
      }
    }
  }, {
    key: "checkForLinks",
    value: function checkForLinks(target) {
      this.linkPresent = false;
      if (target.closest('a') || target.nodeName === "A") {
        this.linkPresent = true;
        this.destinationUrl = target.closest('a') ? target.closest('a').getAttribute('href') : target.getAttribute('href');
      }
    }
  }, {
    key: "checkForAssets",
    value: function checkForAssets(target) {
      this.assetPresent = false;
      if (target.querySelector('img') || target.nodeName === 'IMG') {
        this.interactedAsset = target.querySelector('img') ? target.querySelector('img').src : target.src;
        this.assetPresent = true;
      }
      if (target.querySelector('video') || target.nodeName === 'VIDEO') {
        this.interactedAsset = target.querySelector('video') ? target.querySelector('video').src : target.src;
        this.assetPresent = true;
      }
      if (target.querySelector('span') || target.nodeName === 'SPAN') {
        this.interactedAsset = target.querySelector('span') ? target.querySelector('span').innerText : target.innerText;
        this.assetPresent = true;
      }
    }
  }, {
    key: "setListener",
    value: function setListener(listenerTarget, eventType) {
      var _this68 = this;
      listenerTarget.addEventListener("".concat(eventType), function (event) {
        if (_this68.navEvent) {
          _this68.trackingData = _this68.buildNavTrackingObject(event);
        } else {
          _this68.trackingData = _this68.buildTrackingObject(event);
        }
        if (_this68.trackingData !== null && !event.target.classList.contains('product-form__variant-input')) {
          debounce(_this68.sendDataToPixel('user_interaction', _this68.trackingData), 200);
        }
      });
    }
  }, {
    key: "sendDataToPixel",
    value: function sendDataToPixel(eventName, data) {
      Shopify.analytics.publish("".concat(eventName), data);
    }
  }]);
  return SectionTracker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('section-tracker', SectionTracker);
var ProductEssentials = /*#__PURE__*/function (_HTMLElement28) {
  _inherits(ProductEssentials, _HTMLElement28);
  var _super36 = _createSuper(ProductEssentials);
  function ProductEssentials() {
    var _this69;
    _classCallCheck(this, ProductEssentials);
    _this69 = _super36.call(this);
    _this69.defineElems();
    _this69.defineProps();
    _this69.defineListeners();
    _this69.fetchSiblings();
    return _this69;
  }
  _createClass(ProductEssentials, [{
    key: "defineElems",
    value: function defineElems() {
      this.siblingWrapper = this.querySelector(".product-essentials__color-sibling");
      this.summaryDropdown = this.querySelector(".product-essentials__item");
      this.price = this.querySelector(".price-item");
      this.productAtc = document.querySelector("product-atc");
      this.quantityWraper = this.querySelector(".product-essentials__quantity-input");
      this.quantityField = this.quantityWraper.querySelector('.quantity__input');
      this.decreaseButton = this.quantityWraper.querySelector('[name="minus"]');
      this.increaseButton = this.quantityWraper.querySelector('[name="plus"]');
    }
  }, {
    key: "defineProps",
    value: function defineProps() {
      var _this$quantityField;
      this.handleProductValue = this.dataset.handle;
      this.selectedVariant;
      this.dropdownCheck = false;
      this.formattedPrice = this.price.getAttribute('data-price');
      this.currentValue = parseInt(((_this$quantityField = this.quantityField) === null || _this$quantityField === void 0 ? void 0 : _this$quantityField.value) || '1', 10);
    }
  }, {
    key: "defineListeners",
    value: function defineListeners() {
      var _this70 = this;
      this.summaryDropdown.addEventListener('click', this.setDrawListeners.bind(this));
      if (!this.quantityWraper) return;
      if (this.decreaseButton) {
        this.decreaseButton.addEventListener('click', function () {
          return _this70.updateQuantity(_this70.quantityField);
        });
      }
      if (this.increaseButton) {
        this.increaseButton.addEventListener('click', function () {
          return _this70.updateQuantity(_this70.quantityField);
        });
      }
      this.quantityField.addEventListener('change', function () {
        return _this70.updateQuantity(_this70.quantityField);
      });
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(quantityField) {
      if (Number(quantityField.value) > Number(quantityField.dataset.maxQty)) {
        quantityField.value = quantityField.dataset.maxQty;
        this.currentValue = parseInt(quantityField.dataset.maxQty, 10);
      } else {
        this.currentValue = parseInt(quantityField.value, 10);
      }
      if (isNaN(this.currentValue)) {
        this.currentValue = 1;
      }
      this.updatePriceOnQtyChange();
      this.updatePayload();
    }
  }, {
    key: "updatePriceOnQtyChange",
    value: function updatePriceOnQtyChange() {
      this.newPrice = this.currentValue * parseFloat(this.formattedPrice);
      this.priceElement = this.querySelector(".price-item");
      var formattedPrice = Shopify.formatMoney(this.newPrice, Shopify.moneyFormat);
      this.priceElement.innerHTML = formattedPrice;
    }
  }, {
    key: "setSiblingListeners",
    value: function setSiblingListeners(siblings) {
      var _this71 = this;
      siblings.forEach(function (sibling) {
        sibling.addEventListener('click', _this71.updateOnSiblingClick.bind(_this71));
      });
    }
  }, {
    key: "fetchSiblings",
    value: function () {
      var _fetchSiblings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var _this72 = this;
        var productData;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return fetch("https://".concat(window.location.hostname, "/products/").concat(this.handleProductValue, "?sections=product-colour-sibling-section")).then( /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(response) {
                    var formattedData;
                    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                      while (1) {
                        switch (_context30.prev = _context30.next) {
                          case 0:
                            _context30.next = 2;
                            return response.json();
                          case 2:
                            formattedData = _context30.sent;
                            return _context30.abrupt("return", formattedData);
                          case 4:
                          case "end":
                            return _context30.stop();
                        }
                      }
                    }, _callee30);
                  }));
                  return function (_x25) {
                    return _ref7.apply(this, arguments);
                  };
                }()).then(function (formattedData) {
                  var parser = new DOMParser();
                  var markUp = parser.parseFromString(formattedData['product-colour-sibling-section'], 'text/html');
                  var colourSibling = markUp.querySelector('colour-sibling');
                  if (colourSibling) {
                    _this72.siblingWrapper.append(colourSibling);
                    _this72.selectedVariant = _this72.querySelector('.product-selected');
                  } else {
                    // In the event of no colour siblings on the product, selected variant data will be
                    // pulled from the ProductEssentials element itself
                    _this72.selectedVariant = _this72;
                  }
                }).then(function () {
                  _this72.siblings = _this72.querySelectorAll("colour-sibling a") ? _this72.querySelectorAll("colour-sibling a") : null;
                  // This ternaray operator stops setting sibling listeners, for when there are no sibs
                  _this72.siblings !== null ? _this72.setSiblingListeners(_this72.siblings) : null;
                  _this72.renderInitialProduct();
                  if (_this72.dataset.isBundle === "true") {
                    _this72.addProductToPayloadOnOpen(_this72.selectedVariant);
                  }
                });
              case 2:
                productData = _context31.sent;
              case 3:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
      function fetchSiblings() {
        return _fetchSiblings.apply(this, arguments);
      }
      return fetchSiblings;
    }()
  }, {
    key: "renderInitialProduct",
    value: function renderInitialProduct() {
      // define elements to update
      this.featuredImage = this.querySelector("#productPictureSrcSet");
      this.colourTitle = this.querySelector('.stock-colour');
      this.productURL = this.querySelector('.product-essentials__featured-image');
      this.essentialProductName = this.querySelector('.product-essential__product-title');
      this.setImageWidth = "&width=80";
      // update elements with data from this.selectedVariant
      this.featuredImage.setAttribute("src", this.selectedVariant.getAttribute('data-featured-image-url') + this.setImageWidth);
      this.colourTitle.innerHTML = this.selectedVariant.getAttribute('data-colour-title');
      this.productURL = this.querySelector('.product-essentials__featured-image').setAttribute('href', this.selectedVariant.getAttribute('data-product-url'));
      this.setTitleUrl = this.querySelector('.product-essentials__product-name').setAttribute('href', this.selectedVariant.getAttribute('data-product-url'));
      this.essentialProductName.innerHTML = this.selectedVariant.getAttribute('data-colour-product-name');
    }
  }, {
    key: "updateOnSiblingClick",
    value: function () {
      var _updateOnSiblingClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var _this73 = this;
        var variantToChange;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                this.colourSiblingTarget = event.currentTarget;
                variantToChange = Array.from(this.productAtc.payload).find(function (variantInPayload) {
                  return variantInPayload.handle == _this73.selectedVariant.dataset.productHandle;
                });
                this.getUpdatedColourProps();
                this.getElementsToUpdateWithColour();
                this.updateProductAtc(variantToChange);
                this.updateProductColourData();
                this.checkMaxInventory();
                this.adjustSelectedColour();
                this.selectedVariant = this.colourSiblingTarget;
              case 9:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
      function updateOnSiblingClick() {
        return _updateOnSiblingClick.apply(this, arguments);
      }
      return updateOnSiblingClick;
    }()
  }, {
    key: "adjustSelectedColour",
    value: function adjustSelectedColour() {
      // update select classes
      this.siblings.forEach(function (thumbnail) {
        thumbnail.classList.remove("product-selected");
      });
      this.colourSiblingTarget.classList.add("product-selected");
    }
  }, {
    key: "checkMaxInventory",
    value: function checkMaxInventory() {
      // max inventory check
      this.quantityField.dataset.maxQty = this.colourSiblingTarget.dataset.maxQty;
      this.quantityField.setAttribute('max', Number(this.colourSiblingTarget.dataset.maxQty));
      if (Number(this.quantityField.value) > Number(this.quantityField.dataset.maxQty)) {
        this.quantityField.value = this.quantityField.dataset.maxQty;
      }
    }
  }, {
    key: "updateProductAtc",
    value: function updateProductAtc(variantToChange) {
      // updates ProductAtc Payload
      variantToChange.variantID = this.colourSiblingTarget.dataset.productId;
      variantToChange.handle = this.colourSiblingTarget.dataset.productHandle;
      variantToChange.quantity = this.currentValue;
      variantToChange.price = this.colourSiblingTarget.dataset.productPrice * this.currentValue;
    }
  }, {
    key: "getUpdatedColourProps",
    value: function getUpdatedColourProps() {
      this.colourSiblingTargetID = this.colourSiblingTarget.dataset.productId;
      this.colourSiblingTargetTitle = this.colourSiblingTarget.dataset.colourTitle;
      this.colourSiblingTargetAvailability = this.colourSiblingTarget.dataset.colourAvailable;
      this.colourSiblingTargetFeaturedImage = this.colourSiblingTarget.dataset.featuredImageUrl;
      this.colourSiblingTargetImageUrl = this.colourSiblingTarget.dataset.productUrl;
      this.colourSiblingTargetProductName = this.colourSiblingTarget.dataset.colourProductName;
      this.getColourSiblingStyling = this.colourSiblingTarget.querySelector('div').getAttribute('style');
    }
  }, {
    key: "getElementsToUpdateWithColour",
    value: function getElementsToUpdateWithColour() {
      this.inStockTitleColour = this.querySelector('.stock-colour');
      this.productTitle = this.querySelector('.product-essential__product-title');
      this.productPicture = this.querySelector("#productPictureSrcSet");
      this.inStockProductPictureUrl = this.querySelector('.product-essentials__featured-image');
      this.productName = this.querySelector('.product-essentials__product-name');
      this.setDivStyle = this.querySelector('.product-essentials__featured-image').setAttribute('style', this.getColourSiblingStyling);
    }
  }, {
    key: "updateProductColourData",
    value: function updateProductColourData() {
      this.productPicture.setAttribute("src", this.colourSiblingTargetFeaturedImage + this.setImageWidth);
      this.inStockTitleColour.innerHTML = this.colourSiblingTargetTitle;
      this.inStockProductPictureUrl.setAttribute("href", this.colourSiblingTargetImageUrl);
      this.productName.setAttribute("href", this.colourSiblingTargetImageUrl);
      this.productTitle.innerHTML = this.colourSiblingTargetProductName;
    }
  }, {
    key: "setDrawListeners",
    value: function setDrawListeners() {
      var _this74 = this;
      var detailsElement = this.querySelector('details');
      if (detailsElement && !detailsElement.hasAttribute('data-listener-added')) {
        detailsElement.addEventListener('toggle', function (event) {
          if (detailsElement.open) {
            // Ternerary op sets default variant for when colour siblings are never rendered (in case of no sibs)
            if (_this74.dataset.isBundle === 'true') return;
            _this74.selectedProduct = _this74.querySelector('.product-selected') ? _this74.querySelector('.product-selected') : _this74.selectedVariant;
            return _this74.addProductToPayloadOnOpen(_this74.selectedProduct);
          } else {
            if (_this74.dataset.isBundle === 'true') return;
            _this74.removedProductPayload = _this74.productAtc.payload;
            _this74.removedProduct = _this74.querySelector('.product-selected') ? _this74.querySelector('.product-selected') : _this74.selectedVariant;
            return _this74.removeProductFromPayloadOnClose(_this74.removedProductPayload, _this74.removedProduct);
          }
        });
        detailsElement.setAttribute('data-listener-added', 'true');
      }
    }
  }, {
    key: "addProductToPayloadOnOpen",
    value: function addProductToPayloadOnOpen(payload) {
      this.payloadSiblingTargetID = payload.dataset.productId;
      this.payloadSiblingTargetHandle = payload.dataset.productHandle;
      this.payloadSiblingPrice = payload.dataset.productPrice;
      var addon = {
        "variantID": this.payloadSiblingTargetID,
        "quantity": this.currentValue,
        "handle": this.payloadSiblingTargetHandle,
        "price": this.payloadSiblingPrice * this.currentValue
      };
      this.addonID = addon.variantID;
      this.productAtc.payload.push(addon);
      this.productAtc.calculateProductATCPrice();
      this.productAtc.addQuantityToBag();
    }
  }, {
    key: "updatePayload",
    value: function updatePayload() {
      var addonUpdated = {
        variantID: this.selectedVariant.dataset.productId,
        quantity: this.currentValue,
        handle: this.selectedVariant.dataset.productHandle,
        price: this.selectedVariant.dataset.productPrice * this.currentValue
      };
      var addon = this.productAtc.payload.find(function (addon) {
        return addon.variantID === addonUpdated.variantID;
      });
      if (addon) {
        addon.quantity = addonUpdated.quantity;
        addon.handle = addonUpdated.handle;
        addon.price = addonUpdated.price;
      }
      this.productAtc.addQuantityToBag();
      this.productAtc.calculateProductATCPrice();
    }
  }, {
    key: "removeProductFromPayloadOnClose",
    value: function removeProductFromPayloadOnClose(itemToRemovePayload, removedProduct) {
      var removeItemID = removedProduct.getAttribute('data-product-id');
      var updatedRemovalPayload = itemToRemovePayload.filter(function (item) {
        return item.variantID !== removeItemID;
      });
      this.productAtc.payload = updatedRemovalPayload;
      this.productAtc.removeQuantityToBag();
      this.productAtc.calculateProductATCPrice();
      this.productAtc.addQuantityToBag();
    }
  }]);
  return ProductEssentials;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-essentials', ProductEssentials);
var ProductBundles = /*#__PURE__*/function (_HTMLElement29) {
  _inherits(ProductBundles, _HTMLElement29);
  var _super37 = _createSuper(ProductBundles);
  function ProductBundles() {
    var _this75;
    _classCallCheck(this, ProductBundles);
    _this75 = _super37.call(this);
    _this75.defineElems();
    _this75.defineProps();
    _this75.defineListeners();
    _this75.fetchSiblings();
    _this75.updatePriceOnQtyChange();
    return _this75;
  }
  _createClass(ProductBundles, [{
    key: "defineElems",
    value: function defineElems() {
      this.productWrapper = this.closest('.product__info-container');
      this.bundleWrapperTitle = this.productWrapper.querySelector('.product-bundles_title');
      this.siblingWrapper = this.querySelector(".product-bundles__color-sibling");
      this.summaryDropdown = this.querySelector(".product-bundles__item");
      this.price = this.querySelector(".price-item");
      this.quantityLabelValue = this.querySelector('.bundle-component__qty .bundle-component__qty--value');
      this.productAtc = document.querySelector("product-atc");
      this.quantityWraper = this.querySelector(".product-bundles__quantity-input");
      this.quantityField = this.quantityWraper.querySelector('.quantity__input');
    }
  }, {
    key: "defineProps",
    value: function defineProps() {
      var _this$quantityField2;
      this.handleProductValue = this.dataset.handle;
      this.enableCartTransform = this.dataset.enableCartTransfrom === 'true' ? true : false;
      this.selectedVariant;
      this.bundleVariantId = this.dataset.bundleParentVariantId;
      this.bundleParentImage = this.dataset.bundleParentImage;
      this.formattedPrice = this.price.getAttribute('data-price');
      this.currentValue = parseInt(((_this$quantityField2 = this.quantityField) === null || _this$quantityField2 === void 0 ? void 0 : _this$quantityField2.value) || '1', 10);
      this.bundleParentTitle = this.dataset.bundleParentTitle;
      this.allBundleComponents = document.querySelectorAll('product-bundle');
      this.bundleCount = this.allBundleComponents.length;
      this.bundleIndex = this.dataset.bundleIndex;
      if (this.enableCartTransform === true) {
        this.charPool = 'abcdefghijklmnopqrstuvxwyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        this.bundleKey = '';
        this.setBundleKeys();
      }
    }
  }, {
    key: "defineListeners",
    value: function defineListeners() {
      var _this76 = this;
      if (!this.quantityWraper) return;
      this.quantityField.addEventListener('change', function () {
        return _this76.updateQuantity(_this76.quantityField);
      });
      this.quantityField.addEventListener('bundle-change', function () {
        return _this76.updateQuantity(_this76.quantityField);
      });
      this.handleKeyWatcher();
    }
  }, {
    key: "handleKeyWatcher",
    value: function handleKeyWatcher() {
      this.observer = new MutationObserver(this.setBundleKeys.bind(this));
      this.observerConfig = {
        attributes: true,
        childList: false,
        subtree: false
      };
      this.observer.observe(this.bundleWrapperTitle, this.observerConfig);
    }
  }, {
    key: "setBundleKeys",
    value: function setBundleKeys() {
      if (this.bundleWrapperTitle.dataset.bundleKey === '') {
        this.bundleKey = '';
        for (var i = 0; i < 6; i++) {
          this.bundleKey += "".concat(String(this.charPool.charAt(Math.floor(Math.random() * (51 - 1) + 1))));
        }
        this.bundleKey = "".concat(this.bundleKey, "-").concat(this.bundleIndex);
        this.bundleWrapperTitle.setAttribute('data-bundle-key', this.bundleKey.split('-')[0]);
      } else {
        this.bundleKey = "".concat(this.bundleWrapperTitle.dataset.bundleKey, "-").concat(this.bundleIndex);
      }
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(quantityField) {
      var newValue = Number(quantityField.value * this.productAtc.productQuantity);
      if (newValue > Number(quantityField.dataset.maxQty)) {
        quantityField.value = quantityField.dataset.maxQty;
        this.currentValue = parseInt(quantityField.dataset.maxQty, 10);
      } else {
        this.currentValue = parseInt(newValue, 10);
      }
      if (isNaN(this.currentValue)) {
        this.currentValue = 1;
      }
      this.quantityLabelValue.innerText = this.currentValue;
      this.updatePriceOnQtyChange();
      this.updatePayload();
    }
  }, {
    key: "updatePriceOnQtyChange",
    value: function updatePriceOnQtyChange() {
      this.newPrice = this.currentValue * parseFloat(this.formattedPrice);
      var formattedPrice = Shopify.formatMoney(this.newPrice, Shopify.moneyFormat);
      this.price.innerHTML = formattedPrice;
    }
  }, {
    key: "setSiblingListeners",
    value: function setSiblingListeners(siblings) {
      var _this77 = this;
      siblings.forEach(function (sibling) {
        sibling.addEventListener('click', _this77.updateOnSiblingClick.bind(_this77));
      });
    }
  }, {
    key: "fetchSiblings",
    value: function () {
      var _fetchSiblings2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var _this78 = this;
        var productData;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return fetch("https://".concat(window.location.hostname, "/products/").concat(this.handleProductValue, "?sections=product-colour-sibling-section")).then( /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(response) {
                    var formattedData;
                    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            _context33.next = 2;
                            return response.json();
                          case 2:
                            formattedData = _context33.sent;
                            return _context33.abrupt("return", formattedData);
                          case 4:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33);
                  }));
                  return function (_x26) {
                    return _ref8.apply(this, arguments);
                  };
                }()).then(function (formattedData) {
                  var parser = new DOMParser();
                  var markUp = parser.parseFromString(formattedData['product-colour-sibling-section'], 'text/html');
                  var colourSibling = markUp.querySelector('colour-sibling');
                  if (colourSibling) {
                    _this78.siblingWrapper.append(colourSibling);
                    _this78.selectedVariant = _this78.querySelector('.product-selected') !== null ? _this78.querySelector('.product-selected') : _this78;
                  } else {
                    // In the event of no colour siblings on the product, selected variant data will be
                    // pulled from the ProductBundle element itself
                    _this78.selectedVariant = _this78;
                  }
                }).then(function () {
                  _this78.siblings = _this78.querySelectorAll("colour-sibling a") ? _this78.querySelectorAll("colour-sibling a") : null;
                  // This ternaray operator stops setting sibling listeners, for when there are no sibs
                  _this78.siblings !== null ? _this78.setSiblingListeners(_this78.siblings) : null;
                  _this78.renderInitialProduct();
                  _this78.addProductToPayloadOnOpen(_this78.selectedVariant);
                });
              case 2:
                productData = _context34.sent;
              case 3:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
      function fetchSiblings() {
        return _fetchSiblings2.apply(this, arguments);
      }
      return fetchSiblings;
    }()
  }, {
    key: "renderInitialProduct",
    value: function renderInitialProduct() {
      // define elements to update
      this.featuredImage = this.querySelector("#productPictureSrcSet");
      this.colourTitle = this.querySelector('.stock-colour');
      this.productURL = this.querySelector('.product-bundles__featured-image');
      this.bundleComponentName = this.querySelector('.product-bundles__product-title');
      this.setImageWidth = "&width=80";
      // update elements with data from this.selectedVariant
      this.featuredImage.setAttribute("src", this.selectedVariant.getAttribute('data-featured-image-url') + this.setImageWidth);
      this.colourTitle.innerHTML = this.selectedVariant.getAttribute('data-colour-title');
      this.productURL = this.querySelector('.product-bundles__featured-image').setAttribute('href', this.selectedVariant.getAttribute('data-product-url'));
      this.setTitleUrl = this.querySelector('.product-bundles__product-name').setAttribute('href', this.selectedVariant.getAttribute('data-product-url'));
      this.bundleComponentName.innerHTML = this.selectedVariant.getAttribute('data-colour-product-name');
    }
  }, {
    key: "updateOnSiblingClick",
    value: function () {
      var _updateOnSiblingClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var _this79 = this;
        var variantToChange;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                this.colourSiblingTarget = event.currentTarget;
                variantToChange = Array.from(this.productAtc.payload).find(function (variantInPayload) {
                  return variantInPayload.handle == _this79.selectedVariant.dataset.productHandle;
                });
                this.getUpdatedColourProps();
                this.getElementsToUpdateWithColour();
                this.updateProductAtc(variantToChange);
                this.updateProductColourData();
                this.checkMaxInventory();
                this.adjustSelectedColour();
                this.selectedVariant = this.colourSiblingTarget;
              case 9:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
      function updateOnSiblingClick() {
        return _updateOnSiblingClick2.apply(this, arguments);
      }
      return updateOnSiblingClick;
    }()
  }, {
    key: "adjustSelectedColour",
    value: function adjustSelectedColour() {
      // update select classes
      this.siblings.forEach(function (thumbnail) {
        thumbnail.classList.remove("product-selected");
      });
      this.colourSiblingTarget.classList.add("product-selected");
    }
  }, {
    key: "checkMaxInventory",
    value: function checkMaxInventory() {
      // max inventory check
      this.quantityField.dataset.maxQty = this.colourSiblingTarget.dataset.maxQty;
      this.quantityField.setAttribute('max', Number(this.colourSiblingTarget.dataset.maxQty));
      if (Number(this.quantityField.value) > Number(this.quantityField.dataset.maxQty)) {
        this.quantityField.value = this.quantityField.dataset.maxQty;
      }
    }
  }, {
    key: "updateProductAtc",
    value: function updateProductAtc(variantToChange) {
      // updates ProductAtc Payload;
      variantToChange.variantID = this.colourSiblingTarget.dataset.productId;
      variantToChange.handle = this.colourSiblingTarget.dataset.productHandle;
      variantToChange.quantity = this.currentValue;
      variantToChange.price = this.colourSiblingTarget.dataset.productPrice * this.currentValue;
      if (this.enableCartTransform === true) {
        variantToChange.properties = {
          "_bundle_component": "true",
          "_bundle_title": this.bundleParentTitle,
          "_component_title": this.bundleComponentName.innerText,
          "_bundle_variant_id": this.bundleVariantId,
          "_bundle_variant_image": this.bundleParentImage,
          "_bundle_key": this.bundleKey.split('-')[0]
        };
      }
    }
  }, {
    key: "getUpdatedColourProps",
    value: function getUpdatedColourProps() {
      this.colourSiblingTargetID = this.colourSiblingTarget.dataset.productId;
      this.colourSiblingTargetTitle = this.colourSiblingTarget.dataset.colourTitle;
      this.colourSiblingTargetAvailability = this.colourSiblingTarget.dataset.colourAvailable;
      this.colourSiblingTargetFeaturedImage = this.colourSiblingTarget.dataset.featuredImageUrl;
      this.colourSiblingTargetImageUrl = this.colourSiblingTarget.dataset.productUrl;
      this.colourSiblingTargetProductName = this.colourSiblingTarget.dataset.colourProductName;
      this.getColourSiblingStyling = this.colourSiblingTarget.querySelector('div').getAttribute('style');
    }
  }, {
    key: "getElementsToUpdateWithColour",
    value: function getElementsToUpdateWithColour() {
      this.inStockTitleColour = this.querySelector('.stock-colour');
      this.productTitle = this.querySelector('.product-bundles__product-title');
      this.productPicture = this.querySelector("#productPictureSrcSet");
      this.inStockProductPictureUrl = this.querySelector('.product-bundles__featured-image');
      this.productName = this.querySelector('.product-bundles__product-name');
      this.setDivStyle = this.querySelector('.product-bundles__featured-image').setAttribute('style', this.getColourSiblingStyling);
    }
  }, {
    key: "updateProductColourData",
    value: function updateProductColourData() {
      this.productPicture.setAttribute("src", this.colourSiblingTargetFeaturedImage + this.setImageWidth);
      this.inStockTitleColour.innerHTML = this.colourSiblingTargetTitle;
      this.inStockProductPictureUrl.setAttribute("href", this.colourSiblingTargetImageUrl);
      this.productName.setAttribute("href", this.colourSiblingTargetImageUrl);
      this.productTitle.innerHTML = this.colourSiblingTargetProductName;
    }
  }, {
    key: "addProductToPayloadOnOpen",
    value: function addProductToPayloadOnOpen(payload) {
      this.payloadSiblingTargetID = payload.dataset.productId;
      this.payloadSiblingTargetHandle = payload.dataset.productHandle;
      this.payloadSiblingPrice = payload.dataset.productPrice;
      var addon = {
        "variantID": this.payloadSiblingTargetID,
        "quantity": this.currentValue,
        "handle": this.payloadSiblingTargetHandle,
        "price": this.payloadSiblingPrice * this.currentValue
      };
      if (this.enableCartTransform === true) {
        addon.properties = {
          "_bundle_component": "true",
          "_bundle_title": this.bundleParentTitle,
          "_component_title": this.bundleComponentName.innerText,
          "_bundle_variant_id": this.bundleVariantId,
          "_bundle_variant_image": this.bundleParentImage,
          "_bundle_key": this.bundleKey.split('-')[0]
        };
      }
      this.addonID = addon.variantID;
      this.productAtc.payload.push(addon);
      this.productAtc.addQuantityToBag();
    }
  }, {
    key: "updatePayload",
    value: function updatePayload() {
      var addonUpdated = {
        variantID: this.selectedVariant.dataset.productId,
        quantity: this.currentValue,
        handle: this.selectedVariant.dataset.productHandle,
        price: this.selectedVariant.dataset.productPrice * this.currentValue
      };
      var addon = this.productAtc.payload.find(function (addon) {
        return addon.variantID === addonUpdated.variantID;
      });
      if (addon) {
        addon.quantity = addonUpdated.quantity;
        addon.handle = addonUpdated.handle;
        addon.price = addonUpdated.price;
      }
      this.productAtc.addQuantityToBag();
    }
  }]);
  return ProductBundles;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('product-bundle', ProductBundles);